export default {
    zh: {
        // 页面标题
        pageTitle: 'AI Kissing',
        previewTitle: 'AI Kissing Video Generator',
        
        // 标签
        labelType: '类型',
        labelImage: '图片',
        
        // Type 类型
        typeFrenchKiss: 'AI 法式接吻',
        typeGeneral: '常规',
        typeKissMe: '吻我AI',
        typeCheekKiss: '亲吻脸颊',
        
        // 上传相关
        addImage: '上传图片',
        clickToUpload: '点击上传图片',
        uploading: '上传中',
        
        // 开关选项
        backgroundMusic: '背景音乐',
        publicVisibility: '公开可见',
        copyProtection: '版权保护',
        
        // Tooltip 提示信息
        backgroundMusicTooltip: '启用后，您可以从我们为您准备的音乐曲目中选择，添加到生成的视频中。',
        publicVisibilityTooltip: '开启此选项后， WeryAI可能会选中你的作品并将其发布到社区目录。',
        copyrightProtectionTooltip: '保护您的上传图片、视频和提示词不被展示在社区中。一旦启用此选项，其他WeryAI用户将无法在社区中看到您为生成此内容上传的图片、视频和提示词。',
        
        // 提示信息
        imageTip: '请上传一张包含一个或两个人的图片，图片会自动生成接吻视频效果。',
        maxTwoImages: '最多只能上传2张图片',
        pleaseSelectImage: '请选择图片文件',
        imageTooLarge: '图片大小不能超过100MB',
        uploadSuccess: '上传成功',
        uploadFailed: '上传失败',
        noPreview: '暂无预览视频',
        
        // 错误和状态提示
        errorNoImage: '请至少上传一张图片',
        infoStart: '任务已成功提交！',
        failedSubmit: '提交任务失败',
        errorGeneral: '创建视频失败',
        
        // 按钮信息
        btnInfo: '免费试用 AI 接吻视频生成器',
        
        // 介绍部分
        introduceTitle: 'AI 亲吻视频生成器，让两张照片"一吻定情"',
        introduceDesc: '想看你的偶像和二次元角色亲吻？或者让你和爱人的合照动起来？WeryAI 亲吻视频生成器，只需两张照片，即可生成逼真的接吻视频。无论是浪漫的法式深吻、甜蜜的脸颊亲吻还是俏皮的飞吻，AI 都能完美呈现，让创意跨越次元壁！',
        
        // 选择理由部分
        selectReasonTitle: '为什么选择 WeryAI 亲吻视频生成器？',
        reason1Title: '超逼真 AI 动作，丝滑不僵硬',
        reason1Desc: '拒绝"人工智障"般的生硬动作！得益于最先进的图像驱动算法，WeryAI 生成的亲吻视频拥有流畅的头部运动、自然的面部微表情和真实的皮肤纹理，带给你宛如亲临现场的视觉冲击。',
        reason2Title: '多种亲吻模式，定制专属浪漫',
        reason2Desc: '从温柔的浅尝辄止，到热烈的法式湿吻 (French Kiss)，再到充满爱意的亲吻脸颊。您可以自由输入提示词（Prompt），精准控制亲吻的风格和强度，制作出完全符合您想象的亲密瞬间。',
        reason3Title: '万物皆可"吻"，创意无极限',
        reason3Desc: '打破现实束缚！你可以让两个毫不相干的名人"官宣"，让家里的猫咪和狗狗"相亲相爱"，甚至让雕像与画中人"坠入爱河"。WeryAI 支持真人、动漫、宠物、雕塑等多种题材的混搭，是制作爆款 Meme（迷因）的神器。',
        reason4Title: '社交媒体吸睛利器',
        reason4Desc: '厌倦了平淡的图文？用一个独特的 AI 亲吻视频在 TikTok、Instagram 或朋友圈脱颖而出！无论是节日表白、恶搞朋友，还是制作营销素材，这都是一种能瞬间抓住眼球的全新方式。',
        
        // 常见问题部分
        faqTitle: '常见问题解答',
        faq1Question: '什么是 AI 亲吻视频生成器？',
        faq1Answer: '它是一款利用深度学习技术，将静态图片转化为动态亲吻视频的 AI 工具。你只需上传照片，WeryAI 就能分析人物面部特征，自动生成两人（或一人与一物）接吻的流畅动画，广泛用于娱乐、社交分享和创意制作。',
        faq2Question: '我可以制作什么样的亲吻视频？',
        faq2Answer: '几乎没有任何限制！你可以制作情侣间的浪漫法式亲吻、朋友间的玩笑亲脸颊、甚至是跨越次元的人机之恋。只要你有创意，AI 就能帮你实现。',
        faq3Question: '生成的亲吻视频看起来真实吗？',
        faq3Answer: '非常真实。WeryAI 采用行业领先的图像驱动模型，专注于优化面部接触时的物理逻辑和皮肤质感，确保生成的亲吻动作既流畅又自然，极大程度减少了传统 AI 视频的"违和感"。',
        faq4Question: '我可以免费使用 AI 接吻生成器吗？',
        faq4Answer: '是的！我们提供免费试用积分，让每位用户都能体验 AI 创作的乐趣。您可以免费生成视频并预览效果，满意后再决定是否升级以获取更高清的画质。',
        faq5Question: '我的照片隐私安全吗？',
        faq5Answer: '绝对安全。我们非常重视您的隐私。所有上传的图片仅用于当次视频生成，处理完成后会从服务器自动删除，绝不会被存储或用于其他用途。',
        faq6Question: '支持哪些图片格式？',
        faq6Answer: '我们支持 JPG, PNG, WEBP 等主流图片格式。为了获得最佳的亲吻效果，建议上传五官清晰、光线良好的照片，分辨率建议在 512x512 像素以上。',
        
        // 使用教程部分
        howToUseTitle: '如何使用我们的 AI 亲吻视频生成器？',
        howToUseDesc: '三步，让照片陷入热恋：',
        step1Title: '步骤 1 上传照片',
        step1Desc: '选择两张您想要"撮合"的人物、宠物或角色照片（单人照或合照均可）。',
        step2Title: '第 2 步 选择模式',
        step2Desc: '选择您想要的亲吻类型（如：法式深吻、亲脸颊、亲手背等），或输入自定义提示词。',
        step3Title: '步骤3 生成视频',
        step3Desc: '点击生成，AI 将在几秒内施展魔法，为您呈上一段甜蜜或搞笑的亲吻视频！',
        
        // 探索其他工具部分
        exploreOthersTitle: '探索 WeryAI 的其他热门视频特效',
        aiDancing: 'AI 跳舞',
        videoFaceSwap: 'AI 视频换脸',
        videoToAnime: 'AI 视频转动漫',
        videoUpscaler: '视频增强',
        
        // 模型介绍部分
        modelIntroTitle: '释放你的创造力，开始使用 WeryAI 生成神奇的接吻视频',
        modelIntroDescription: '尝试我们的 AI 接吻视频生成器',
        modelIntroButtonText: '免费试用WeryAI 亲吻视频生成器',
        modelIntroFooterText: '无需信用卡',
    },
    en: {
        // Page Title
        pageTitle: 'AI Kissing',
        previewTitle: 'AI Kissing Video Generator',
        
        // Labels
        labelType: 'Type',
        labelImage: 'Image',
        
        // Type Types
        typeFrenchKiss: 'AI French Kiss',
        typeGeneral: 'General',
        typeKissMe: 'Kiss Me AI',
        typeCheekKiss: 'Cheek Kiss',
        
        // Upload Related
        addImage: 'Add Image',
        clickToUpload: 'Click to upload an image',
        uploading: 'Uploading...',
        
        // Switch Options
        backgroundMusic: 'Background Music',
        publicVisibility: 'Make Public',
        copyProtection: 'Copyright Protection',
        
        // Tooltip Messages
        backgroundMusicTooltip: 'If enabled, you can choose from the following music tracks we\'ve prepared for you to add to the generated video.',
        publicVisibilityTooltip: 'By enabling this option, WeryAI may select your works and publish it to the community directory.',
        copyrightProtectionTooltip: 'Protect your uploaded images, videos and prompts from being displayed in the community. Once enabled, other WeryAI users will not be able to see the images, videos, and prompts you uploaded to generate this content in the community.',
        
        // Prompt Messages
        imageTip: 'Please upload one image containing one or two people. The video will automatically generate a kissing effect.',
        maxTwoImages: 'Maximum 2 images allowed',
        pleaseSelectImage: 'Please select an image file',
        imageTooLarge: 'Image size should not exceed 100MB',
        uploadSuccess: 'Upload successful',
        uploadFailed: 'Upload failed',
        noPreview: 'No preview video available',
        
        // Error and Status Messages
        errorNoImage: 'Please upload at least one image',
        infoStart: 'Task submitted successfully!',
        failedSubmit: 'Failed to submit task',
        errorGeneral: 'Failed to create video',
        
        // Button Info
        btnInfo: 'Try AI Kissing Video Generator for Free',
        
        // Introduction Section
        introduceTitle: 'AI Kissing Video Generator - Bring Two Photos to Life with a Kiss',
        introduceDesc: 'Want to see your idol kiss an anime character? Or bring your couple photos to life? WeryAI Kissing Video Generator needs just two photos to create realistic kissing videos. Whether it\'s a romantic French kiss, a sweet cheek kiss, or a playful air kiss, AI perfectly recreates it all, breaking through dimensional barriers with creativity!',
        
        // Reason Selection Section
        selectReasonTitle: 'Why Choose WeryAI Kissing Video Generator?',
        reason1Title: 'Ultra-Realistic AI Motion, Smooth and Natural',
        reason1Desc: 'Say goodbye to stiff, robotic movements! Thanks to cutting-edge image-driven algorithms, WeryAI generates kissing videos with fluid head movements, natural facial micro-expressions, and realistic skin textures, delivering a visual experience that feels like you\'re actually there.',
        reason2Title: 'Multiple Kiss Modes, Customize Your Romance',
        reason2Desc: 'From gentle pecks to passionate French kisses and loving cheek kisses. You can freely input prompts to precisely control the style and intensity of the kiss, creating intimate moments that perfectly match your imagination.',
        reason3Title: 'Everything Can Kiss - Unlimited Creativity',
        reason3Desc: 'Break free from reality! Make two unrelated celebrities "go public", have your cat and dog "fall in love", or even make a statue kiss a painting character. WeryAI supports mixing real people, anime, pets, sculptures, and more—perfect for creating viral memes.',
        reason4Title: 'Social Media Attention Grabber',
        reason4Desc: 'Tired of plain text and images? Stand out on TikTok, Instagram, or your social feed with a unique AI kissing video! Whether it\'s a holiday confession, pranking friends, or creating marketing materials, this is a brand new way to instantly catch attention.',
        
        // FAQ Section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is an AI Kissing Video Generator?',
        faq1Answer: 'It\'s an AI tool that uses deep learning technology to transform static images into dynamic kissing videos. Simply upload photos, and WeryAI analyzes facial features to automatically generate smooth animations of two people (or a person and object) kissing. It\'s widely used for entertainment, social sharing, and creative production.',
        faq2Question: 'What kind of kissing videos can I create?',
        faq2Answer: 'Almost no limits! You can create romantic French kisses between couples, playful cheek kisses between friends, or even cross-dimensional human-machine romance. As long as you have the creativity, AI can help you realize it.',
        faq3Question: 'Do the generated kissing videos look realistic?',
        faq3Answer: 'Very realistic. WeryAI uses industry-leading image-driven models that focus on optimizing the physics logic and skin texture during facial contact, ensuring the kissing motions are both smooth and natural, greatly reducing the "uncanny valley" effect of traditional AI videos.',
        faq4Question: 'Can I use the AI Kissing Generator for free?',
        faq4Answer: 'Yes! We provide free trial points so every user can experience the fun of AI creation. You can generate videos and preview effects for free, then decide whether to upgrade for higher quality.',
        faq5Question: 'Is my photo privacy safe?',
        faq5Answer: 'Absolutely safe. We take your privacy very seriously. All uploaded images are only used for current video generation and are automatically deleted from servers after processing. They will never be stored or used for other purposes.',
        faq6Question: 'What image formats are supported?',
        faq6Answer: 'We support mainstream image formats like JPG, PNG, and WEBP. For best kissing effects, we recommend uploading photos with clear facial features and good lighting, with a resolution of at least 512x512 pixels.',
        
        // How to Use Section
        howToUseTitle: 'How to Use Our AI Kissing Video Generator?',
        howToUseDesc: 'Three steps to make photos fall in love:',
        step1Title: 'Step 1: Upload Photos',
        step1Desc: 'Choose two photos of people, pets, or characters you want to "match" (single portraits or group photos both work).',
        step2Title: 'Step 2: Select Mode',
        step2Desc: 'Choose your desired kissing type (e.g., French kiss, cheek kiss, hand kiss, etc.), or enter a custom prompt.',
        step3Title: 'Step 3: Generate Video',
        step3Desc: 'Click generate, and AI will work its magic in seconds, presenting you with a sweet or funny kissing video!',
        
        // Explore Others Section
        exploreOthersTitle: 'Explore Other Popular Video Effects at WeryAI',
        aiDancing: 'AI Dancing',
        videoFaceSwap: 'AI Video Face Swap',
        videoToAnime: 'AI Video to Anime',
        videoUpscaler: 'Video Upscaler',
        
        // Model Introduction Section
        modelIntroTitle: 'Unleash Your Creativity and Start Creating Amazing Kissing Videos with WeryAI',
        modelIntroDescription: 'Try Our AI Kissing Video Generator',
        modelIntroButtonText: 'Try WeryAI Kissing Video Generator for Free',
        modelIntroFooterText: 'No Credit Card Required',
    },
    ja: {
        // ページタイトル
        pageTitle: 'AI キス',
        previewTitle: 'AI キス動画ジェネレーター',
        
        // ラベル
        labelType: 'タイプ',
        labelImage: '画像',
        
        // タイプ種類
        typeFrenchKiss: 'AI フレンチキス',
        typeGeneral: '一般',
        typeKissMe: 'キスミー AI',
        typeCheekKiss: '頬キス',
        
        // アップロード関連
        addImage: '画像を追加',
        clickToUpload: '画像をアップロードするにはクリック',
        uploading: 'アップロード中...',
        
        // スイッチオプション
        backgroundMusic: 'バックグラウンドミュージック',
        publicVisibility: '公開表示',
        copyProtection: '著作権保護',
        
        // ツールチップメッセージ
        backgroundMusicTooltip: '有効にすると、生成されたビデオに追加するために用意した音楽トラックから選択できます。',
        publicVisibilityTooltip: 'このオプションを有効にすると、WeryAIはあなたの作品を選択してコミュニティディレクトリに公開することができます。',
        copyrightProtectionTooltip: '保護されたアップロード画像、ビデオとプロンプトは、コミュニティで表示されません。このオプションを有効にすると、他のWeryAIユーザーは、このコンテンツを生成するためにアップロードした画像、ビデオ、およびプロンプトをコミュニティで表示できなくなります。',
        
        // プロンプトメッセージ
        imageTip: '1人または2人が写っている画像を1枚アップロードしてください。ビデオは自動的にキス効果を生成します。',
        maxTwoImages: '最大2枚の画像まで許可されています',
        pleaseSelectImage: '画像ファイルを選択してください',
        imageTooLarge: '画像サイズは100MBを超えないでください',
        uploadSuccess: 'アップロード成功',
        uploadFailed: 'アップロード失敗',
        noPreview: 'プレビュー動画がありません',
        
        // エラーとステータスメッセージ
        errorNoImage: '少なくとも1枚の画像をアップロードしてください',
        infoStart: 'タスクが正常に送信されました！',
        failedSubmit: 'タスクの送信に失敗しました',
        errorGeneral: 'ビデオの作成に失敗しました',
        
        // ボタン情報
        btnInfo: 'AI キス動画ジェネレーターを無料で試す',
        
        // 紹介セクション
        introduceTitle: 'AI キス動画ジェネレーター - 2枚の写真にキスで命を吹き込む',
        introduceDesc: 'アイドルとアニメキャラクターのキスを見たいですか？それともカップルの写真に命を吹き込みたいですか？WeryAI キス動画ジェネレーターは、たった2枚の写真でリアルなキス動画を作成します。ロマンチックなフレンチキス、甘い頬へのキス、遊び心のあるエアキスなど、AIはすべてを完璧に再現し、創造性で次元の壁を打ち破ります！',
        
        // 理由選択セクション
        selectReasonTitle: 'なぜ WeryAI キス動画ジェネレーターを選ぶのか？',
        reason1Title: '超リアルなAIモーション、滑らかで自然',
        reason1Desc: '硬くてロボット的な動きとはさようなら！最先端の画像駆動アルゴリズムのおかげで、WeryAIは流れるような頭の動き、自然な顔の微表情、リアルな肌の質感を持つキス動画を生成し、実際にそこにいるような視覚体験を提供します。',
        reason2Title: '複数のキスモード、ロマンスをカスタマイズ',
        reason2Desc: '優しいキスから情熱的なフレンチキス、愛情深い頬へのキスまで。プロンプトを自由に入力して、キスのスタイルと強度を正確にコントロールし、あなたの想像に完璧にマッチする親密な瞬間を作り出すことができます。',
        reason3Title: 'すべてがキスできる - 無限の創造性',
        reason3Desc: '現実から解放されましょう！無関係な2人の有名人を「公開」させたり、猫と犬を「恋に落ち」させたり、彫像と絵画のキャラクターをキスさせたりすることもできます。WeryAIは実在の人物、アニメ、ペット、彫刻などのミックスをサポートし、バイラルミームの作成に最適です。',
        reason4Title: 'ソーシャルメディアの注目を集めるツール',
        reason4Desc: '平凡なテキストや画像に飽きましたか？ユニークなAIキス動画でTikTok、Instagram、またはソーシャルフィードで目立ちましょう！休日の告白、友達へのいたずら、またはマーケティング素材の作成など、これは瞬時に注目を集める全く新しい方法です。',
        
        // FAQセクション
        faqTitle: 'よくある質問',
        faq1Question: 'AI キス動画ジェネレーターとは何ですか？',
        faq1Answer: 'ディープラーニング技術を使用して静止画像を動的なキス動画に変換するAIツールです。写真をアップロードするだけで、WeryAIが顔の特徴を分析し、2人（または人と物）がキスする滑らかなアニメーションを自動生成します。エンターテインメント、ソーシャルシェア、クリエイティブ制作に広く使用されています。',
        faq2Question: 'どのようなキス動画を作成できますか？',
        faq2Answer: 'ほぼ制限なし！カップル間のロマンチックなフレンチキス、友達間の遊び心のある頬キス、さらには次元を超えた人間と機械のロマンスまで作成できます。創造力があれば、AIがそれを実現します。',
        faq3Question: '生成されたキス動画はリアルに見えますか？',
        faq3Answer: '非常にリアルです。WeryAIは業界をリードする画像駆動モデルを使用し、顔の接触時の物理ロジックと肌の質感の最適化に焦点を当て、キスの動作が滑らかで自然であることを保証し、従来のAI動画の「不気味の谷」効果を大幅に減らしています。',
        faq4Question: 'AI キスジェネレーターを無料で使用できますか？',
        faq4Answer: 'はい！すべてのユーザーがAI創作の楽しさを体験できるように、無料トライアルポイントを提供しています。動画を生成してエフェクトを無料でプレビューし、高品質にアップグレードするかどうかを決定できます。',
        faq5Question: '私の写真のプライバシーは安全ですか？',
        faq5Answer: '絶対に安全です。私たちはあなたのプライバシーを非常に真剣に考えています。アップロードされたすべての画像は現在の動画生成にのみ使用され、処理後にサーバーから自動的に削除されます。他の目的で保存または使用されることは決してありません。',
        faq6Question: 'どの画像形式がサポートされていますか？',
        faq6Answer: 'JPG、PNG、WEBPなどの主流画像形式をサポートしています。最高のキス効果を得るには、顔の特徴が明確で照明が良好な写真をアップロードすることをお勧めします。解像度は少なくとも512x512ピクセルが推奨されます。',
        
        // 使い方セクション
        howToUseTitle: 'AI キス動画ジェネレーターの使い方は？',
        howToUseDesc: '3ステップで写真を恋に落とす：',
        step1Title: 'ステップ1：写真をアップロード',
        step1Desc: '「マッチング」したい人物、ペット、またはキャラクターの写真を2枚選択します（単独のポートレートまたはグループ写真のどちらでも可）。',
        step2Title: 'ステップ2：モードを選択',
        step2Desc: '希望するキスのタイプ（フレンチキス、頬キス、手キスなど）を選択するか、カスタムプロンプトを入力します。',
        step3Title: 'ステップ3：動画を生成',
        step3Desc: '生成をクリックすると、AIが数秒で魔法をかけ、甘いまたは面白いキス動画を提示します！',
        
        // その他を探索セクション
        exploreOthersTitle: 'WeryAI の他の人気動画エフェクトを探索',
        aiDancing: 'AI ダンス',
        videoFaceSwap: 'AI 動画フェイススワップ',
        videoToAnime: 'AI 動画をアニメに',
        videoUpscaler: '動画高画質化',
        
        // モデル紹介セクション
        modelIntroTitle: 'あなたの創造性を解き放ち、WeryAIで素晴らしいキス動画を作成しましょう',
        modelIntroDescription: '私たちのAIキス動画ジェネレーターをお試しください',
        modelIntroButtonText: 'WeryAIキス動画ジェネレーターを無料で試す',
        modelIntroFooterText: 'クレジットカード不要',
    },
    ko: {
        // 페이지 제목
        pageTitle: 'AI 키스',
        previewTitle: 'AI 키스 비디오 생성기',
        
        // 레이블
        labelType: '유형',
        labelImage: '이미지',
        
        // 타입 종류
        typeFrenchKiss: 'AI 프렌치 키스',
        typeGeneral: '일반',
        typeKissMe: '키스미 AI',
        typeCheekKiss: '볼 키스',
        
        // 업로드 관련
        addImage: '이미지 추가',
        clickToUpload: '이미지를 업로드하려면 클릭',
        uploading: '업로드 중...',
        
        // 스위치 옵션
        backgroundMusic: '배경 음악',
        publicVisibility: '공개 표시',
        copyProtection: '저작권 보호',
        
        // 툴팁 메시지
        backgroundMusicTooltip: '활성화하면 생성된 비디오에 추가할 수 있도록 준비한 음악 트랙 중에서 선택할 수 있습니다.',
        publicVisibilityTooltip: '이 옵션을 활성화하면 WeryAI가 작품을 선택하여 커뮤니티 디렉토리에 게시할 수 있습니다.',
        copyrightProtectionTooltip: '보호된 업로드 이미지, 비디오와 프롬프트는 커뮤니티에 표시되지 않습니다. 이 옵션을 활성화하면 다른 WeryAI 사용자는 이 콘텐츠를 생성하기 위해 업로드한 이미지, 비디오, 프롬프트를 커뮤니티에서 볼 수 없게 됩니다.',
        
        // 프롬프트 메시지
        imageTip: '한 사람 또는 두 사람이 포함된 이미지 한 장을 업로드하세요. 비디오는 자동으로 키스 효과를 생성합니다.',
        maxTwoImages: '최대 2장의 이미지만 허용됩니다',
        pleaseSelectImage: '이미지 파일을 선택하세요',
        imageTooLarge: '이미지 크기는 100MB를 초과할 수 없습니다',
        uploadSuccess: '업로드 성공',
        uploadFailed: '업로드 실패',
        noPreview: '미리보기 비디오가 없습니다',
        
        // 오류 및 상태 메시지
        errorNoImage: '최소 1개의 이미지를 업로드하세요',
        infoStart: '작업이 성공적으로 제출되었습니다!',
        failedSubmit: '작업 제출 실패',
        errorGeneral: '비디오 생성 실패',
        
        // 버튼 정보
        btnInfo: 'AI 키스 비디오 생성기 무료 체험',
        
        // 소개 섹션
        introduceTitle: 'AI 키스 비디오 생성기 - 키스로 두 장의 사진에 생명을 불어넣기',
        introduceDesc: '아이돌과 애니메이션 캐릭터가 키스하는 것을 보고 싶으신가요? 아니면 커플 사진에 생명을 불어넣고 싶으신가요? WeryAI 키스 비디오 생성기는 단 두 장의 사진으로 사실적인 키스 비디오를 만듭니다. 로맨틱한 프렌치 키스, 달콤한 볼 키스, 장난스러운 에어 키스 등 AI가 모든 것을 완벽하게 재현하여 창의성으로 차원의 벽을 뚫습니다!',
        
        // 이유 선택 섹션
        selectReasonTitle: 'WeryAI 키스 비디오 생성기를 선택하는 이유는?',
        reason1Title: '초현실적인 AI 모션, 부드럽고 자연스러움',
        reason1Desc: '뻣뻣하고 로봇 같은 움직임과 작별하세요! 최첨단 이미지 기반 알고리즘 덕분에 WeryAI는 유동적인 머리 움직임, 자연스러운 얼굴 미세 표정, 사실적인 피부 질감을 가진 키스 비디오를 생성하여 실제로 거기 있는 것 같은 시각적 경험을 제공합니다.',
        reason2Title: '여러 키스 모드, 로맨스 맞춤화',
        reason2Desc: '부드러운 키스부터 열정적인 프렌치 키스, 사랑스러운 볼 키스까지. 프롬프트를 자유롭게 입력하여 키스의 스타일과 강도를 정확하게 제어하고 상상에 완벽하게 맞는 친밀한 순간을 만들 수 있습니다.',
        reason3Title: '모든 것이 키스할 수 있습니다 - 무한한 창의성',
        reason3Desc: '현실에서 벗어나세요! 관련 없는 두 유명인을 "공개"하게 하거나, 고양이와 개를 "사랑에 빠지게" 하거나, 조각상과 그림 속 캐릭터가 키스하도록 할 수도 있습니다. WeryAI는 실제 사람, 애니메이션, 애완동물, 조각 등의 혼합을 지원하며 바이럴 밈 제작에 완벽합니다.',
        reason4Title: '소셜 미디어 주목 도구',
        reason4Desc: '평범한 텍스트와 이미지에 지치셨나요? 독특한 AI 키스 비디오로 TikTok, Instagram 또는 소셜 피드에서 눈에 띄세요! 휴일 고백, 친구 장난, 마케팅 자료 제작 등 이것은 즉시 주목을 끄는 완전히 새로운 방법입니다.',
        
        // FAQ 섹션
        faqTitle: '자주 묻는 질문',
        faq1Question: 'AI 키스 비디오 생성기란 무엇입니까?',
        faq1Answer: '딥러닝 기술을 사용하여 정적 이미지를 동적 키스 비디오로 변환하는 AI 도구입니다. 사진을 업로드하기만 하면 WeryAI가 얼굴 특징을 분석하여 두 사람(또는 사람과 물체)이 키스하는 부드러운 애니메이션을 자동으로 생성합니다. 엔터테인먼트, 소셜 공유 및 창의적 제작에 널리 사용됩니다.',
        faq2Question: '어떤 종류의 키스 비디오를 만들 수 있나요?',
        faq2Answer: '거의 제한이 없습니다! 커플 간의 로맨틱한 프렌치 키스, 친구 간의 장난스러운 볼 키스, 심지어 차원을 넘어선 인간-기계 로맨스까지 만들 수 있습니다. 창의력만 있다면 AI가 실현해 드립니다.',
        faq3Question: '생성된 키스 비디오는 사실적으로 보이나요?',
        faq3Answer: '매우 사실적입니다. WeryAI는 업계를 선도하는 이미지 기반 모델을 사용하여 얼굴 접촉 시 물리 논리와 피부 질감 최적화에 중점을 두어 키스 동작이 부드럽고 자연스럽게 보장하며 기존 AI 비디오의 "불쾌한 골짜기" 효과를 크게 줄입니다.',
        faq4Question: 'AI 키스 생성기를 무료로 사용할 수 있나요?',
        faq4Answer: '네! 모든 사용자가 AI 창작의 재미를 경험할 수 있도록 무료 평가판 포인트를 제공합니다. 비디오를 생성하고 효과를 무료로 미리 볼 수 있으며, 더 높은 품질로 업그레이드할지 결정할 수 있습니다.',
        faq5Question: '내 사진 개인 정보는 안전한가요?',
        faq5Answer: '절대 안전합니다. 귀하의 개인 정보를 매우 진지하게 생각합니다. 업로드된 모든 이미지는 현재 비디오 생성에만 사용되며 처리 후 서버에서 자동으로 삭제됩니다. 다른 목적으로 저장하거나 사용하지 않습니다.',
        faq6Question: '어떤 이미지 형식이 지원되나요?',
        faq6Answer: 'JPG, PNG, WEBP 등 주류 이미지 형식을 지원합니다. 최상의 키스 효과를 얻으려면 얼굴 특징이 선명하고 조명이 좋은 사진을 업로드하는 것이 좋으며, 해상도는 최소 512x512 픽셀이 권장됩니다.',
        
        // 사용 방법 섹션
        howToUseTitle: 'AI 키스 비디오 생성기 사용 방법은?',
        howToUseDesc: '3단계로 사진이 사랑에 빠지게 하기:',
        step1Title: '1단계: 사진 업로드',
        step1Desc: '"매칭"하고 싶은 사람, 애완동물 또는 캐릭터의 사진 두 장을 선택하세요(개별 초상화 또는 그룹 사진 모두 가능).',
        step2Title: '2단계: 모드 선택',
        step2Desc: '원하는 키스 유형(프렌치 키스, 볼 키스, 손 키스 등)을 선택하거나 맞춤 프롬프트를 입력하세요.',
        step3Title: '3단계: 비디오 생성',
        step3Desc: '생성을 클릭하면 AI가 몇 초 안에 마법을 부려 달콤하거나 재미있는 키스 비디오를 제공합니다!',
        
        // 다른 것 탐색 섹션
        exploreOthersTitle: 'WeryAI의 다른 인기 비디오 효과 탐색',
        aiDancing: 'AI 댄싱',
        videoFaceSwap: 'AI 비디오 페이스 스왑',
        videoToAnime: 'AI 비디오를 애니메이션으로',
        videoUpscaler: '비디오 향상',
        
        // 모델 소개 섹션
        modelIntroTitle: 'WeryAI로 창의력을 발휘하고 놀라운 키스 비디오 제작을 시작하세요',
        modelIntroDescription: 'AI 키스 비디오 생성기를 사용해 보세요',
        modelIntroButtonText: 'WeryAI 키스 비디오 생성기 무료 체험',
        modelIntroFooterText: '신용카드 불필요',
    },
    es: {
        // Título de la página
        pageTitle: 'AI Kissing',
        previewTitle: 'Generador de Videos de Besos con IA',
        
        // Etiquetas
        labelType: 'Tipo',
        labelImage: 'Imagen',
        
        // Tipos
        typeFrenchKiss: 'Beso Francés con IA',
        typeGeneral: 'General',
        typeKissMe: 'Bésame IA',
        typeCheekKiss: 'Beso en la Mejilla',
        
        // Relacionado con carga
        addImage: 'Añadir Imagen',
        clickToUpload: 'Haz clic para subir una imagen',
        uploading: 'Subiendo...',
        
        // Opciones de interruptor
        backgroundMusic: 'Música de Fondo',
        publicVisibility: 'Hacer Público',
        copyProtection: 'Protección de Derechos de Autor',
        
        // Mensajes de información
        backgroundMusicTooltip: 'Si está habilitado, puede elegir entre las pistas musicales que hemos preparado para usted para agregar al video generado.',
        publicVisibilityTooltip: 'Al habilitar esta opción, WeryAI puede seleccionar su obra y publicarlo en el directorio de la comunidad.',
        copyrightProtectionTooltip: 'Protege tus imágenes, videos y sugerencias cargados de ser mostrados en la comunidad. Una vez habilitado, otros usuarios de WeryAI no podrán ver las imágenes, videos y sugerencias que cargó para generar este contenido en la comunidad.',
        
        // Mensajes de aviso
        imageTip: 'Por favor, sube una imagen que contenga una o dos personas. El video generará automáticamente un efecto de beso.',
        maxTwoImages: 'Máximo 2 imágenes permitidas',
        pleaseSelectImage: 'Por favor, selecciona un archivo de imagen',
        imageTooLarge: 'El tamaño de la imagen no debe exceder los 100MB',
        uploadSuccess: 'Carga exitosa',
        uploadFailed: 'Error en la carga',
        noPreview: 'No hay video de vista previa disponible',
        
        // Mensajes de Error y Estado
        errorNoImage: 'Por favor, sube al menos una imagen',
        infoStart: '¡Tarea enviada con éxito!',
        failedSubmit: 'Error al enviar la tarea',
        errorGeneral: 'Error al crear el video',
        
        // Información del botón
        btnInfo: 'Prueba Gratis el Generador de Videos de Besos con IA',
        
        // Sección de introducción
        introduceTitle: 'Generador de Videos de Besos con IA - Da Vida a Dos Fotos con un Beso',
        introduceDesc: '¿Quieres ver a tu ídolo besar a un personaje de anime? ¿O dar vida a tus fotos de pareja? El Generador de Videos de Besos de WeryAI solo necesita dos fotos para crear videos de besos realistas. Ya sea un romántico beso francés, un dulce beso en la mejilla o un juguetón beso al aire, la IA lo recrea todo perfectamente, ¡rompiendo barreras dimensionales con creatividad!',
        
        // Sección de razones
        selectReasonTitle: '¿Por Qué Elegir el Generador de Videos de Besos de WeryAI?',
        reason1Title: 'Movimiento de IA Ultra Realista, Suave y Natural',
        reason1Desc: '¡Adiós a los movimientos rígidos y robóticos! Gracias a algoritmos de vanguardia basados en imágenes, WeryAI genera videos de besos con movimientos de cabeza fluidos, microexpresiones faciales naturales y texturas de piel realistas, ofreciendo una experiencia visual que se siente como si estuvieras realmente allí.',
        reason2Title: 'Múltiples Modos de Beso, Personaliza tu Romance',
        reason2Desc: 'Desde suaves besos hasta apasionados besos franceses y amorosos besos en la mejilla. Puedes ingresar libremente prompts para controlar con precisión el estilo e intensidad del beso, creando momentos íntimos que coincidan perfectamente con tu imaginación.',
        reason3Title: 'Todo Puede Besar - Creatividad Ilimitada',
        reason3Desc: '¡Libérate de la realidad! Haz que dos celebridades no relacionadas "se hagan públicas", que tu gato y perro "se enamoren", o incluso que una estatua bese a un personaje de una pintura. WeryAI admite mezclar personas reales, anime, mascotas, esculturas y más, perfecto para crear memes virales.',
        reason4Title: 'Captador de Atención en Redes Sociales',
        reason4Desc: '¿Cansado del texto e imágenes planas? ¡Destaca en TikTok, Instagram o tu feed social con un video de besos con IA único! Ya sea una confesión de vacaciones, gastar bromas a amigos o crear materiales de marketing, esta es una forma completamente nueva de captar atención al instante.',
        
        // Sección de preguntas frecuentes
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Qué es un Generador de Videos de Besos con IA?',
        faq1Answer: 'Es una herramienta de IA que usa tecnología de aprendizaje profundo para transformar imágenes estáticas en videos dinámicos de besos. Simplemente sube fotos, y WeryAI analiza las características faciales para generar automáticamente animaciones fluidas de dos personas (o una persona y un objeto) besándose. Se usa ampliamente para entretenimiento, compartir en redes sociales y producción creativa.',
        faq2Question: '¿Qué tipo de videos de besos puedo crear?',
        faq2Answer: '¡Casi sin límites! Puedes crear besos franceses románticos entre parejas, besos en la mejilla juguetones entre amigos, o incluso romance entre humanos y máquinas de dimensiones cruzadas. Mientras tengas creatividad, la IA puede ayudarte a realizarlo.',
        faq3Question: '¿Los videos de besos generados se ven realistas?',
        faq3Answer: 'Muy realistas. WeryAI usa modelos líderes en la industria basados en imágenes que se centran en optimizar la lógica física y la textura de la piel durante el contacto facial, asegurando que los movimientos de beso sean suaves y naturales, reduciendo enormemente el efecto de "valle inquietante" de los videos de IA tradicionales.',
        faq4Question: '¿Puedo usar el Generador de Besos con IA gratis?',
        faq4Answer: '¡Sí! Proporcionamos puntos de prueba gratuitos para que cada usuario pueda experimentar la diversión de la creación con IA. Puedes generar videos y previsualizar efectos gratis, luego decidir si actualizar para mayor calidad.',
        faq5Question: '¿Es segura la privacidad de mis fotos?',
        faq5Answer: 'Absolutamente segura. Nos tomamos muy en serio tu privacidad. Todas las imágenes cargadas solo se usan para la generación de video actual y se eliminan automáticamente de los servidores después del procesamiento. Nunca se almacenarán ni usarán para otros propósitos.',
        faq6Question: '¿Qué formatos de imagen se admiten?',
        faq6Answer: 'Admitimos formatos de imagen principales como JPG, PNG y WEBP. Para mejores efectos de beso, recomendamos subir fotos con características faciales claras y buena iluminación, con una resolución de al menos 512x512 píxeles.',
        
        // Sección de cómo usar
        howToUseTitle: '¿Cómo Usar Nuestro Generador de Videos de Besos con IA?',
        howToUseDesc: 'Tres pasos para hacer que las fotos se enamoren:',
        step1Title: 'Paso 1: Sube Fotos',
        step1Desc: 'Elige dos fotos de personas, mascotas o personajes que quieras "emparejar" (tanto retratos individuales como fotos grupales funcionan).',
        step2Title: 'Paso 2: Selecciona el Modo',
        step2Desc: 'Elige tu tipo de beso deseado (por ejemplo, beso francés, beso en la mejilla, beso en la mano, etc.), o ingresa un prompt personalizado.',
        step3Title: 'Paso 3: Genera el Video',
        step3Desc: '¡Haz clic en generar y la IA hará su magia en segundos, presentándote un video de besos dulce o divertido!',
        
        // Sección de explorar otros
        exploreOthersTitle: 'Explora Otros Efectos de Video Populares en WeryAI',
        aiDancing: 'Baile con IA',
        videoFaceSwap: 'Intercambio de Rostros en Video con IA',
        videoToAnime: 'Video a Anime con IA',
        videoUpscaler: 'Mejorador de Video',
        
        // Sección de introducción del modelo
        modelIntroTitle: 'Libera Tu Creatividad y Comienza a Crear Videos de Besos Increíbles con WeryAI',
        modelIntroDescription: 'Prueba Nuestro Generador de Videos de Besos con IA',
        modelIntroButtonText: 'Prueba Gratis el Generador de Videos de Besos de WeryAI',
        modelIntroFooterText: 'No Se Requiere Tarjeta de Crédito',
    },
    fr: {
        // Titre de la page
        pageTitle: 'AI Kissing',
        previewTitle: 'Générateur de Vidéos de Baisers IA',
        
        // Étiquettes
        labelType: 'Type',
        labelImage: 'Image',
        
        // Types
        typeFrenchKiss: 'Baiser Français IA',
        typeGeneral: 'Général',
        typeKissMe: 'Embrasse-moi IA',
        typeCheekKiss: 'Baiser sur la Joue',
        
        // Lié au téléchargement
        addImage: 'Ajouter une Image',
        clickToUpload: 'Cliquez pour télécharger une image',
        uploading: 'Téléchargement en cours...',
        
        // Options de commutation
        backgroundMusic: 'Musique de Fond',
        publicVisibility: 'Rendre Public',
        copyProtection: 'Protection du Droit d\'Auteur',
        
        // Messages d\'info-bulle
        backgroundMusicTooltip: 'Si activé, vous pouvez choisir parmi les pistes musicales que nous avons préparées pour vous à ajouter à la vidéo générée.',
        publicVisibilityTooltip: 'En activant cette option, WeryAI peut sélectionner votre obra et la publier dans le répertoire communautaire.',
        copyrightProtectionTooltip: 'Protège vos images, vidéos et suggestions chargés de ne pas être affichés dans la communauté. Une fois activé, d\'autres utilisateurs de WeryAI ne pourront pas voir les images, vidéos et suggestions que vous avez chargé pour générer ce contenu dans la communauté.',
        
        // Messages d\'invite
        imageTip: 'Veuillez télécharger une image contenant une ou deux personnes. La vidéo générera automatiquement un effet de baiser.',
        maxTwoImages: 'Maximum 2 images autorisées',
        pleaseSelectImage: 'Veuillez sélectionner un fichier image',
        imageTooLarge: 'La taille de l\'image ne doit pas dépasser 10 Mo',
        uploadSuccess: 'Téléchargement réussi',
        uploadFailed: 'Échec du téléchargement',
        noPreview: 'Aucune vidéo de prévisualisation disponible',
        
        // Messages d\'Erreur et de Statut
        errorNoImage: 'Veuillez télécharger au moins une image',
        infoStart: 'Tâche soumise avec succès !',
        failedSubmit: 'Échec de la soumission de la tâche',
        errorGeneral: 'Échec de la création de la vidéo',
        
        // Informations sur le bouton
        btnInfo: 'Essayez Gratuitement le Générateur de Vidéos de Baisers IA',
        
        // Section d\'introduction
        introduceTitle: 'Générateur de Vidéos de Baisers IA - Donnez Vie à Deux Photos avec un Baiser',
        introduceDesc: 'Vous voulez voir votre idole embrasser un personnage d\'anime ? Ou donner vie à vos photos de couple ? Le Générateur de Vidéos de Baisers de WeryAI n\'a besoin que de deux photos pour créer des vidéos de baisers réalistes. Qu\'il s\'agisse d\'un baiser français romantique, d\'un doux baiser sur la joue ou d\'un baiser aérien ludique, l\'IA recrée tout parfaitement, brisant les barrières dimensionnelles avec créativité !',
        
        // Section des raisons
        selectReasonTitle: 'Pourquoi Choisir le Générateur de Vidéos de Baisers de WeryAI ?',
        reason1Title: 'Mouvement IA Ultra-Réaliste, Fluide et Naturel',
        reason1Desc: 'Dites adieu aux mouvements rigides et robotiques ! Grâce à des algorithmes de pointe basés sur les images, WeryAI génère des vidéos de baisers avec des mouvements de tête fluides, des micro-expressions faciales naturelles et des textures de peau réalistes, offrant une expérience visuelle comme si vous y étiez vraiment.',
        reason2Title: 'Plusieurs Modes de Baiser, Personnalisez Votre Romance',
        reason2Desc: 'Des baisers doux aux baisers français passionnés et aux baisers affectueux sur la joue. Vous pouvez saisir librement des prompts pour contrôler précisément le style et l\'intensité du baiser, créant des moments intimes qui correspondent parfaitement à votre imagination.',
        reason3Title: 'Tout Peut S\'Embrasser - Créativité Illimitée',
        reason3Desc: 'Libérez-vous de la réalité ! Faites que deux célébrités non liées "se révèlent au public", que votre chat et chien "tombent amoureux", ou même qu\'une statue embrasse un personnage de peinture. WeryAI prend en charge le mélange de vraies personnes, d\'anime, d\'animaux de compagnie, de sculptures et plus encore - parfait pour créer des mèmes viraux.',
        reason4Title: 'Capteur d\'Attention sur les Réseaux Sociaux',
        reason4Desc: 'Fatigué du texte et des images ordinaires ? Démarquez-vous sur TikTok, Instagram ou votre fil social avec une vidéo de baiser IA unique ! Qu\'il s\'agisse d\'une confession de vacances, d\'une farce à des amis ou de la création de matériel marketing, c\'est une toute nouvelle façon d\'attirer instantanément l\'attention.',
        
        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',
        faq1Question: 'Qu\'est-ce qu\'un Générateur de Vidéos de Baisers IA ?',
        faq1Answer: 'C\'est un outil IA qui utilise la technologie d\'apprentissage profond pour transformer des images statiques en vidéos dynamiques de baisers. Téléchargez simplement des photos, et WeryAI analyse les caractéristiques faciales pour générer automatiquement des animations fluides de deux personnes (ou une personne et un objet) s\'embrassant. Il est largement utilisé pour le divertissement, le partage social et la production créative.',
        faq2Question: 'Quel type de vidéos de baisers puis-je créer ?',
        faq2Answer: 'Presque sans limites ! Vous pouvez créer des baisers français romantiques entre couples, des baisers sur la joue ludiques entre amis, ou même une romance humain-machine trans-dimensionnelle. Tant que vous avez de la créativité, l\'IA peut vous aider à la réaliser.',
        faq3Question: 'Les vidéos de baisers générées ont-elles l\'air réalistes ?',
        faq3Answer: 'Très réalistes. WeryAI utilise des modèles de pointe basés sur les images qui se concentrent sur l\'optimisation de la logique physique et de la texture de la peau lors du contact facial, garantissant que les mouvements de baiser sont fluides et naturels, réduisant considérablement l\'effet de "vallée dérangeante" des vidéos IA traditionnelles.',
        faq4Question: 'Puis-je utiliser le Générateur de Baisers IA gratuitement ?',
        faq4Answer: 'Oui ! Nous fournissons des points d\'essai gratuits pour que chaque utilisateur puisse découvrir le plaisir de la création IA. Vous pouvez générer des vidéos et prévisualiser les effets gratuitement, puis décider si vous souhaitez passer à une qualité supérieure.',
        faq5Question: 'La confidentialité de mes photos est-elle sécurisée ?',
        faq5Answer: 'Absolument sécurisée. Nous prenons votre confidentialité très au sérieux. Toutes les images téléchargées ne sont utilisées que pour la génération vidéo actuelle et sont automatiquement supprimées des serveurs après le traitement. Elles ne seront jamais stockées ni utilisées à d\'autres fins.',
        faq6Question: 'Quels formats d\'image sont pris en charge ?',
        faq6Answer: 'Nous prenons en charge les formats d\'image courants comme JPG, PNG et WEBP. Pour de meilleurs effets de baiser, nous recommandons de télécharger des photos avec des caractéristiques faciales claires et un bon éclairage, avec une résolution d\'au moins 512x512 pixels.',
        
        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser Notre Générateur de Vidéos de Baisers IA ?',
        howToUseDesc: 'Trois étapes pour faire tomber les photos amoureuses :',
        step1Title: 'Étape 1 : Téléchargez des Photos',
        step1Desc: 'Choisissez deux photos de personnes, d\'animaux de compagnie ou de personnages que vous souhaitez "associer" (les portraits individuels ou les photos de groupe fonctionnent tous les deux).',
        step2Title: 'Étape 2 : Sélectionnez le Mode',
        step2Desc: 'Choisissez votre type de baiser souhaité (par exemple, baiser français, baiser sur la joue, baiser sur la main, etc.), ou entrez un prompt personnalisé.',
        step3Title: 'Étape 3 : Générez la Vidéo',
        step3Desc: 'Cliquez sur générer, et l\'IA fera sa magie en quelques secondes, vous présentant une vidéo de baiser douce ou drôle !',
        
        // Section explorer d\'autres
        exploreOthersTitle: 'Explorez D\'Autres Effets Vidéo Populaires sur WeryAI',
        aiDancing: 'Danse IA',
        videoFaceSwap: 'Échange de Visages Vidéo IA',
        videoToAnime: 'Vidéo vers Anime IA',
        videoUpscaler: 'Amélioration Vidéo',
        
        // Section d'introduction du modèle
        modelIntroTitle: 'Libérez Votre Créativité et Commencez à Créer des Vidéos de Baisers Incroyables avec WeryAI',
        modelIntroDescription: 'Essayez Notre Générateur de Vidéos de Baisers IA',
        modelIntroButtonText: 'Essayez Gratuitement le Générateur de Vidéos de Baisers de WeryAI',
        modelIntroFooterText: 'Aucune Carte de Crédit Requise',
    },
    de: {
        // Seitentitel
        pageTitle: 'AI Kissing',
        previewTitle: 'KI-Kuss-Videogenerator',
        
        // Beschriftungen
        labelType: 'Typ',
        labelImage: 'Bild',
        
        // Typen
        typeFrenchKiss: 'KI-Französischer Kuss',
        typeGeneral: 'Allgemein',
        typeKissMe: 'Küss mich KI',
        typeCheekKiss: 'Wangenkuss',
        
        // Upload-bezogen
        addImage: 'Bild Hinzufügen',
        clickToUpload: 'Klicken Sie, um ein Bild hochzuladen',
        uploading: 'Wird hochgeladen...',
        
        // Schalteroptionen
        backgroundMusic: 'Hintergrundmusik',
        publicVisibility: 'Öffentlich Machen',
        copyProtection: 'Urheberrechtsschutz',
        
        // Tooltip-Nachrichten
        backgroundMusicTooltip: 'Wenn aktiviert, können Sie aus den Musiktiteln wählen, die wir für Sie vorbereitet haben, um sie dem generierten Video hinzuzufügen.',
        publicVisibilityTooltip: 'Durch Aktivieren dieser Option kann WeryAI Ihre Werke auswählen und in das Community-Verzeichnis veröffentlichen.',
        copyrightProtectionTooltip: 'Schützt Ihre hochgeladenen Bilder, Videos und Hinweise davor, in der Community angezeigt zu werden. Wenn diese Option aktiviert ist, können andere WeryAI-Benutzer in der Community nicht sehen, welche Bilder, Videos und Hinweise Sie hochgeladen haben, um diesen Inhalt zu generieren.',
        
        // Hinweisnachrichten
        imageTip: 'Bitte laden Sie ein Bild hoch, das eine oder zwei Personen enthält. Das Video wird automatisch einen Kusseffekt erzeugen.',
        maxTwoImages: 'Maximal 2 Bilder erlaubt',
        pleaseSelectImage: 'Bitte wählen Sie eine Bilddatei aus',
        imageTooLarge: 'Die Bildgröße sollte 100 MB nicht überschreiten',
        uploadSuccess: 'Upload erfolgreich',
        uploadFailed: 'Upload fehlgeschlagen',
        noPreview: 'Kein Vorschauvideo verfügbar',
        
        // Fehler- und Statusmeldungen
        errorNoImage: 'Bitte laden Sie mindestens ein Bild hoch',
        infoStart: 'Aufgabe erfolgreich übermittelt!',
        failedSubmit: 'Fehler beim Übermitteln der Aufgabe',
        errorGeneral: 'Fehler beim Erstellen des Videos',
        
        // Button-Informationen
        btnInfo: 'KI-Kuss-Videogenerator Kostenlos Testen',
        
        // Einführungsabschnitt
        introduceTitle: 'KI-Kuss-Videogenerator - Erwecken Sie Zwei Fotos mit einem Kuss zum Leben',
        introduceDesc: 'Möchten Sie Ihren Idol einen Anime-Charakter küssen sehen? Oder Ihre Paarfotos zum Leben erwecken? Der WeryAI Kuss-Videogenerator benötigt nur zwei Fotos, um realistische Kussvideos zu erstellen. Ob romantischer französischer Kuss, süßer Wangenkuss oder verspielter Luftkuss - die KI kreiert alles perfekt und durchbricht mit Kreativität dimensionale Barrieren!',
        
        // Gründe-Abschnitt
        selectReasonTitle: 'Warum WeryAI Kuss-Videogenerator Wählen?',
        reason1Title: 'Ultra-Realistische KI-Bewegung, Geschmeidig und Natürlich',
        reason1Desc: 'Verabschieden Sie sich von steifen, roboterhaften Bewegungen! Dank modernster bildgesteuerter Algorithmen generiert WeryAI Kussvideos mit fließenden Kopfbewegungen, natürlichen Gesichtsmikroausdrücken und realistischen Hauttexturen und bietet ein visuelles Erlebnis, als wären Sie wirklich dort.',
        reason2Title: 'Mehrere Kussmodi, Personalisieren Sie Ihre Romanze',
        reason2Desc: 'Von sanften Küssen bis zu leidenschaftlichen französischen Küssen und liebevollen Wangenküssen. Sie können frei Prompts eingeben, um Stil und Intensität des Kusses präzise zu steuern und intime Momente zu schaffen, die perfekt zu Ihrer Vorstellung passen.',
        reason3Title: 'Alles Kann Küssen - Unbegrenzte Kreativität',
        reason3Desc: 'Befreien Sie sich von der Realität! Lassen Sie zwei nicht verwandte Prominente "an die Öffentlichkeit gehen", Ihre Katze und Ihren Hund "sich verlieben" oder sogar eine Statue einen Gemäldecharakter küssen. WeryAI unterstützt das Mischen von echten Menschen, Anime, Haustieren, Skulpturen und mehr - perfekt zum Erstellen viraler Memes.',
        reason4Title: 'Social-Media-Aufmerksamkeitsfänger',
        reason4Desc: 'Müde von einfachem Text und Bildern? Stechen Sie auf TikTok, Instagram oder Ihrem Social Feed mit einem einzigartigen KI-Kussvideo heraus! Ob Urlaubsgeständnis, Freunde verarschen oder Marketing-Material erstellen - dies ist eine völlig neue Art, sofort Aufmerksamkeit zu erregen.',
        
        // FAQ-Abschnitt
        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question: 'Was ist ein KI-Kuss-Videogenerator?',
        faq1Answer: 'Es ist ein KI-Tool, das Deep-Learning-Technologie verwendet, um statische Bilder in dynamische Kussvideos zu verwandeln. Laden Sie einfach Fotos hoch, und WeryAI analysiert Gesichtsmerkmale, um automatisch glatte Animationen von zwei Personen (oder einer Person und einem Objekt) beim Küssen zu generieren. Es wird häufig für Unterhaltung, soziales Teilen und kreative Produktion verwendet.',
        faq2Question: 'Welche Art von Kussvideos kann ich erstellen?',
        faq2Answer: 'Fast keine Grenzen! Sie können romantische französische Küsse zwischen Paaren, verspielte Wangenküsse zwischen Freunden oder sogar dimensionsübergreifende Mensch-Maschine-Romanzen erstellen. Solange Sie Kreativität haben, kann KI Ihnen helfen, sie zu verwirklichen.',
        faq3Question: 'Sehen die generierten Kussvideos realistisch aus?',
        faq3Answer: 'Sehr realistisch. WeryAI verwendet branchenführende bildgesteuerte Modelle, die sich auf die Optimierung der physikalischen Logik und Hauttextur beim Gesichtskontakt konzentrieren und sicherstellen, dass die Kussbewegungen geschmeidig und natürlich sind, wodurch der "Uncanny Valley"-Effekt traditioneller KI-Videos erheblich reduziert wird.',
        faq4Question: 'Kann ich den KI-Kuss-Generator kostenlos nutzen?',
        faq4Answer: 'Ja! Wir bieten kostenlose Testpunkte, damit jeder Benutzer den Spaß an der KI-Kreation erleben kann. Sie können Videos kostenlos generieren und Effekte in der Vorschau anzeigen und dann entscheiden, ob Sie für höhere Qualität upgraden möchten.',
        faq5Question: 'Ist die Privatsphäre meiner Fotos sicher?',
        faq5Answer: 'Absolut sicher. Wir nehmen Ihre Privatsphäre sehr ernst. Alle hochgeladenen Bilder werden nur für die aktuelle Videogenerierung verwendet und nach der Verarbeitung automatisch von den Servern gelöscht. Sie werden niemals gespeichert oder für andere Zwecke verwendet.',
        faq6Question: 'Welche Bildformate werden unterstützt?',
        faq6Answer: 'Wir unterstützen gängige Bildformate wie JPG, PNG und WEBP. Für beste Kusseffekte empfehlen wir das Hochladen von Fotos mit klaren Gesichtsmerkmalen und guter Beleuchtung mit einer Auflösung von mindestens 512x512 Pixeln.',
        
        // Anleitungsabschnitt
        howToUseTitle: 'Wie Verwendet Man Unseren KI-Kuss-Videogenerator?',
        howToUseDesc: 'Drei Schritte, um Fotos sich verlieben zu lassen:',
        step1Title: 'Schritt 1: Fotos Hochladen',
        step1Desc: 'Wählen Sie zwei Fotos von Personen, Haustieren oder Charakteren aus, die Sie "zusammenbringen" möchten (sowohl Einzelporträts als auch Gruppenfotos funktionieren).',
        step2Title: 'Schritt 2: Modus Auswählen',
        step2Desc: 'Wählen Sie Ihren gewünschten Kusstyp (z. B. französischer Kuss, Wangenkuss, Handkuss usw.) oder geben Sie einen benutzerdefinierten Prompt ein.',
        step3Title: 'Schritt 3: Video Generieren',
        step3Desc: 'Klicken Sie auf Generieren, und die KI wird in Sekunden ihre Magie entfalten und Ihnen ein süßes oder lustiges Kussvideo präsentieren!',
        
        // Andere erkunden-Abschnitt
        exploreOthersTitle: 'Entdecken Sie Andere Beliebte Videoeffekte bei WeryAI',
        aiDancing: 'KI-Tanzen',
        videoFaceSwap: 'KI-Video-Gesichtstausch',
        videoToAnime: 'Video zu Anime mit KI',
        videoUpscaler: 'Video-Verbesserung',
        
        // Modelleinführungsabschnitt
        modelIntroTitle: 'Entfesseln Sie Ihre Kreativität und Beginnen Sie mit der Erstellung Erstaunlicher Kussvideos mit WeryAI',
        modelIntroDescription: 'Probieren Sie Unseren KI-Kuss-Videogenerator Aus',
        modelIntroButtonText: 'Testen Sie den WeryAI Kuss-Videogenerator Kostenlos',
        modelIntroFooterText: 'Keine Kreditkarte Erforderlich',
    },
    ru: {
        // Заголовок страницы
        pageTitle: 'AI Kissing',
        previewTitle: 'Генератор Видео Поцелуев с ИИ',
        
        // Метки
        labelType: 'Тип',
        labelImage: 'Изображение',
        
        // Типы
        typeFrenchKiss: 'ИИ Французский Поцелуй',
        typeGeneral: 'Общий',
        typeKissMe: 'Поцелуй Меня ИИ',
        typeCheekKiss: 'Поцелуй в Щеку',
        
        // Связанное с загрузкой
        addImage: 'Добавить Изображение',
        clickToUpload: 'Нажмите, чтобы загрузить изображение',
        uploading: 'Загрузка...',
        
        // Параметры переключателя
        backgroundMusic: 'Фоновая Музыка',
        publicVisibility: 'Сделать Публичным',
        copyProtection: 'Защита Авторских Прав',
        
        // Подсказки
        backgroundMusicTooltip: 'При активации вы можете выбрать из музыкальных треков, которые мы подготовили для вас, чтобы добавить их в сгенерированное видео.',
        publicVisibilityTooltip: 'Включив эту опцию, WeryAI может выбрать ваш obra и опубликовать его в каталоге сообщества.',
        copyrightProtectionTooltip: 'Защищает ваши загруженные изображения, видео и подсказки от отображения в сообществе. После включения другие пользователи WeryAI не смогут видеть изображения, видео и подсказки, которые вы загрузили для генерации этого контента в сообществе.',
        
        // Сообщения-подсказки
        imageTip: 'Пожалуйста, загрузите одно изображение с одним или двумя людьми. Видео автоматически создаст эффект поцелуя.',
        maxTwoImages: 'Разрешено максимум 2 изображения',
        pleaseSelectImage: 'Пожалуйста, выберите файл изображения',
        imageTooLarge: 'Размер изображения не должен превышать 100 МБ',
        uploadSuccess: 'Загрузка успешна',
        uploadFailed: 'Ошибка загрузки',
        noPreview: 'Предварительный просмотр видео недоступен',
        
        // Сообщения об Ошибках и Статусе
        errorNoImage: 'Пожалуйста, загрузите хотя бы одно изображение',
        infoStart: 'Задача успешно отправлена!',
        failedSubmit: 'Не удалось отправить задачу',
        errorGeneral: 'Не удалось создать видео',
        
        // Информация о кнопке
        btnInfo: 'Попробуйте Генератор Видео Поцелуев с ИИ Бесплатно',
        
        // Раздел введения
        introduceTitle: 'Генератор Видео Поцелуев с ИИ - Оживите Две Фотографии Поцелуем',
        introduceDesc: 'Хотите увидеть, как ваш кумир целует аниме-персонажа? Или оживить фотографии вашей пары? Генератору Видео Поцелуев WeryAI нужны всего две фотографии, чтобы создать реалистичные видео поцелуев. Будь то романтический французский поцелуй, милый поцелуй в щеку или игривый воздушный поцелуй, ИИ идеально воссоздает все это, преодолевая измерительные барьеры с креативностью!',
        
        // Раздел причин
        selectReasonTitle: 'Почему Выбрать Генератор Видео Поцелуев WeryAI?',
        reason1Title: 'Ультра-Реалистичное Движение ИИ, Плавное и Естественное',
        reason1Desc: 'Попрощайтесь с жесткими, роботизированными движениями! Благодаря передовым алгоритмам на основе изображений, WeryAI генерирует видео поцелуев с плавными движениями головы, естественными микровыражениями лица и реалистичными текстурами кожи, обеспечивая визуальный опыт, как будто вы действительно там.',
        reason2Title: 'Несколько Режимов Поцелуев, Настройте Свою Романтику',
        reason2Desc: 'От нежных поцелуев до страстных французских поцелуев и любящих поцелуев в щеку. Вы можете свободно вводить подсказки для точного контроля стиля и интенсивности поцелуя, создавая интимные моменты, которые идеально соответствуют вашему воображению.',
        reason3Title: 'Все Может Целоваться - Неограниченная Креативность',
        reason3Desc: 'Освободитесь от реальности! Заставьте двух несвязанных знаменитостей "выйти на публику", позвольте вашей кошке и собаке "влюбиться" или даже заставьте статую поцеловать персонажа картины. WeryAI поддерживает смешивание реальных людей, аниме, домашних животных, скульптур и многого другого - идеально для создания вирусных мемов.',
        reason4Title: 'Привлечение Внимания в Социальных Сетях',
        reason4Desc: 'Устали от простого текста и изображений? Выделитесь в TikTok, Instagram или вашей социальной ленте с уникальным видео поцелуев с ИИ! Будь то праздничное признание, розыгрыш друзей или создание маркетинговых материалов, это совершенно новый способ мгновенно привлечь внимание.',
        
        // Раздел FAQ
        faqTitle: 'Часто Задаваемые Вопросы',
        faq1Question: 'Что такое Генератор Видео Поцелуев с ИИ?',
        faq1Answer: 'Это инструмент ИИ, который использует технологию глубокого обучения для преобразования статических изображений в динамические видео поцелуев. Просто загрузите фотографии, и WeryAI проанализирует черты лица, чтобы автоматически генерировать плавные анимации двух людей (или человека и объекта), целующихся. Он широко используется для развлечений, социального обмена и творческого производства.',
        faq2Question: 'Какие видео поцелуев я могу создать?',
        faq2Answer: 'Почти без ограничений! Вы можете создавать романтические французские поцелуи между парами, игривые поцелуи в щеку между друзьями или даже межразмерный роман человека с машиной. Пока у вас есть креативность, ИИ может помочь вам это реализовать.',
        faq3Question: 'Выглядят ли сгенерированные видео поцелуев реалистично?',
        faq3Answer: 'Очень реалистично. WeryAI использует ведущие в отрасли модели на основе изображений, которые фокусируются на оптимизации физической логики и текстуры кожи во время контакта лица, обеспечивая плавность и естественность движений поцелуев, значительно снижая эффект "зловещей долины" традиционных видео с ИИ.',
        faq4Question: 'Могу ли я использовать Генератор Поцелуев с ИИ бесплатно?',
        faq4Answer: 'Да! Мы предоставляем бесплатные пробные баллы, чтобы каждый пользователь мог испытать удовольствие от создания с помощью ИИ. Вы можете генерировать видео и предварительно просматривать эффекты бесплатно, а затем решить, стоит ли обновляться для более высокого качества.',
        faq5Question: 'Безопасна ли конфиденциальность моих фотографий?',
        faq5Answer: 'Абсолютно безопасна. Мы очень серьезно относимся к вашей конфиденциальности. Все загруженные изображения используются только для текущей генерации видео и автоматически удаляются с серверов после обработки. Они никогда не будут храниться или использоваться для других целей.',
        faq6Question: 'Какие форматы изображений поддерживаются?',
        faq6Answer: 'Мы поддерживаем основные форматы изображений, такие как JPG, PNG и WEBP. Для лучших эффектов поцелуев мы рекомендуем загружать фотографии с четкими чертами лица и хорошим освещением, с разрешением не менее 512x512 пикселей.',
        
        // Раздел как использовать
        howToUseTitle: 'Как Использовать Наш Генератор Видео Поцелуев с ИИ?',
        howToUseDesc: 'Три шага, чтобы заставить фотографии влюбиться:',
        step1Title: 'Шаг 1: Загрузите Фотографии',
        step1Desc: 'Выберите две фотографии людей, домашних животных или персонажей, которых вы хотите "свести" (подходят как отдельные портреты, так и групповые фотографии).',
        step2Title: 'Шаг 2: Выберите Режим',
        step2Desc: 'Выберите желаемый тип поцелуя (например, французский поцелуй, поцелуй в щеку, поцелуй руки и т. д.) или введите пользовательскую подсказку.',
        step3Title: 'Шаг 3: Сгенерируйте Видео',
        step3Desc: 'Нажмите "Сгенерировать", и ИИ сотворит свое волшебство за секунды, представив вам милое или забавное видео поцелуев!',
        
        // Раздел исследовать другие
        exploreOthersTitle: 'Исследуйте Другие Популярные Видеоэффекты на WeryAI',
        aiDancing: 'ИИ Танцы',
        videoFaceSwap: 'ИИ Замена Лица в Видео',
        videoToAnime: 'Видео в Аниме с ИИ',
        videoUpscaler: 'Улучшение Видео',
        
        // Раздел введения модели
        modelIntroTitle: 'Раскройте Свой Творческий Потенциал и Начните Создавать Потрясающие Видео Поцелуев с WeryAI',
        modelIntroDescription: 'Попробуйте Наш Генератор Видео Поцелуев с ИИ',
        modelIntroButtonText: 'Попробуйте Генератор Видео Поцелуев WeryAI Бесплатно',
        modelIntroFooterText: 'Кредитная Карта Не Требуется',
    },
    pt: {
        // Título da página
        pageTitle: 'AI Kissing',
        previewTitle: 'Gerador de Vídeos de Beijos com IA',
        
        // Rótulos
        labelType: 'Tipo',
        labelImage: 'Imagem',
        
        // Tipos
        typeFrenchKiss: 'Beijo Francês com IA',
        typeGeneral: 'Geral',
        typeKissMe: 'Beije-me IA',
        typeCheekKiss: 'Beijo na Bochecha',
        
        // Relacionado ao upload
        addImage: 'Adicionar Imagem',
        clickToUpload: 'Clique para carregar uma imagem',
        uploading: 'Carregando...',
        
        // Opções de alternância
        backgroundMusic: 'Música de Fundo',
        publicVisibility: 'Tornar Público',
        copyProtection: 'Proteção de Direitos Autorais',
        
        // Mensagens de dica
        backgroundMusicTooltip: 'Se ativado, você pode escolher entre as faixas de música que preparamos para você adicionar ao vídeo gerado.',
        publicVisibilityTooltip: 'Ativando esta opção, WeryAI pode selecionar seu obra e publicá-lo no catálogo da comunidade.',
        copyrightProtectionTooltip: 'Protege seus imagens, vídeos e sugestões carregados de não serem mostrados na comunidade. Uma vez ativado, outros usuários de WeryAI não poderão ver as imagens, vídeos e sugestões que você carregou para gerar este conteúdo na comunidade.',
        
        // Mensagens de aviso
        imageTip: 'Por favor, carregue uma imagem contendo uma ou duas pessoas. O vídeo gerará automaticamente um efeito de beijo.',
        maxTwoImages: 'Máximo de 2 imagens permitidas',
        pleaseSelectImage: 'Por favor, selecione um arquivo de imagem',
        imageTooLarge: 'O tamanho da imagem não deve exceder 100MB',
        uploadSuccess: 'Upload bem-sucedido',
        uploadFailed: 'Falha no upload',
        noPreview: 'Nenhum vídeo de visualização disponível',
        
        // Mensagens de Erro e Status
        errorNoImage: 'Por favor, carregue pelo menos uma imagem',
        infoStart: 'Tarefa enviada com sucesso!',
        failedSubmit: 'Falha ao enviar tarefa',
        errorGeneral: 'Falha ao criar vídeo',
        
        // Informações do botão
        btnInfo: 'Experimente Grátis o Gerador de Vídeos de Beijos com IA',
        
        // Seção de introdução
        introduceTitle: 'Gerador de Vídeos de Beijos com IA - Dê Vida a Duas Fotos com um Beijo',
        introduceDesc: 'Quer ver seu ídolo beijar um personagem de anime? Ou dar vida às suas fotos de casal? O Gerador de Vídeos de Beijos da WeryAI precisa apenas de duas fotos para criar vídeos de beijos realistas. Seja um beijo francês romântico, um doce beijo na bochecha ou um beijo no ar brincalhão, a IA recria tudo perfeitamente, quebrando barreiras dimensionais com criatividade!',
        
        // Seção de razões
        selectReasonTitle: 'Por Que Escolher o Gerador de Vídeos de Beijos da WeryAI?',
        reason1Title: 'Movimento de IA Ultra-Realista, Suave e Natural',
        reason1Desc: 'Diga adeus aos movimentos rígidos e robóticos! Graças aos algoritmos de ponta baseados em imagens, a WeryAI gera vídeos de beijos com movimentos de cabeça fluidos, microexpressões faciais naturais e texturas de pele realistas, oferecendo uma experiência visual que parece que você está realmente lá.',
        reason2Title: 'Múltiplos Modos de Beijo, Personalize Seu Romance',
        reason2Desc: 'De beijos suaves a beijos franceses apaixonados e beijos amorosos na bochecha. Você pode inserir livremente prompts para controlar com precisão o estilo e intensidade do beijo, criando momentos íntimos que combinam perfeitamente com sua imaginação.',
        reason3Title: 'Tudo Pode Beijar - Criatividade Ilimitada',
        reason3Desc: 'Liberte-se da realidade! Faça duas celebridades não relacionadas "se tornarem públicas", faça seu gato e cachorro "se apaixonarem", ou até mesmo faça uma estátua beijar um personagem de pintura. A WeryAI suporta misturar pessoas reais, anime, animais de estimação, esculturas e muito mais - perfeito para criar memes virais.',
        reason4Title: 'Captador de Atenção nas Redes Sociais',
        reason4Desc: 'Cansado de texto e imagens simples? Destaque-se no TikTok, Instagram ou seu feed social com um vídeo de beijo com IA único! Seja uma confissão de feriado, pregar peças em amigos ou criar materiais de marketing, esta é uma maneira totalmente nova de chamar atenção instantaneamente.',
        
        // Seção de perguntas frequentes
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'O que é um Gerador de Vídeos de Beijos com IA?',
        faq1Answer: 'É uma ferramenta de IA que usa tecnologia de aprendizado profundo para transformar imagens estáticas em vídeos dinâmicos de beijos. Basta fazer upload de fotos e a WeryAI analisa as características faciais para gerar automaticamente animações suaves de duas pessoas (ou uma pessoa e um objeto) se beijando. É amplamente usado para entretenimento, compartilhamento social e produção criativa.',
        faq2Question: 'Que tipo de vídeos de beijos posso criar?',
        faq2Answer: 'Quase sem limites! Você pode criar beijos franceses românticos entre casais, beijos na bochecha brincalhões entre amigos, ou até romance humano-máquina trans-dimensional. Enquanto você tiver criatividade, a IA pode ajudá-lo a realizá-la.',
        faq3Question: 'Os vídeos de beijos gerados parecem realistas?',
        faq3Answer: 'Muito realistas. A WeryAI usa modelos líderes da indústria baseados em imagens que focam em otimizar a lógica física e textura da pele durante o contato facial, garantindo que os movimentos de beijo sejam suaves e naturais, reduzindo muito o efeito de "vale estranho" dos vídeos de IA tradicionais.',
        faq4Question: 'Posso usar o Gerador de Beijos com IA gratuitamente?',
        faq4Answer: 'Sim! Fornecemos pontos de teste gratuitos para que cada usuário possa experimentar a diversão da criação com IA. Você pode gerar vídeos e visualizar efeitos gratuitamente, depois decidir se deseja atualizar para maior qualidade.',
        faq5Question: 'A privacidade das minhas fotos está segura?',
        faq5Answer: 'Absolutamente segura. Levamos sua privacidade muito a sério. Todas as imagens carregadas são usadas apenas para a geração de vídeo atual e são automaticamente excluídas dos servidores após o processamento. Elas nunca serão armazenadas ou usadas para outros propósitos.',
        faq6Question: 'Quais formatos de imagem são suportados?',
        faq6Answer: 'Suportamos formatos de imagem comuns como JPG, PNG e WEBP. Para melhores efeitos de beijo, recomendamos fazer upload de fotos com características faciais claras e boa iluminação, com resolução de pelo menos 512x512 pixels.',
        
        // Seção de como usar
        howToUseTitle: 'Como Usar Nosso Gerador de Vídeos de Beijos com IA?',
        howToUseDesc: 'Três passos para fazer as fotos se apaixonarem:',
        step1Title: 'Passo 1: Carregue Fotos',
        step1Desc: 'Escolha duas fotos de pessoas, animais de estimação ou personagens que você deseja "combinar" (tanto retratos individuais quanto fotos em grupo funcionam).',
        step2Title: 'Passo 2: Selecione o Modo',
        step2Desc: 'Escolha seu tipo de beijo desejado (por exemplo, beijo francês, beijo na bochecha, beijo na mão, etc.), ou insira um prompt personalizado.',
        step3Title: 'Passo 3: Gere o Vídeo',
        step3Desc: 'Clique em gerar e a IA fará sua mágica em segundos, apresentando-lhe um vídeo de beijo doce ou engraçado!',
        
        // Seção explorar outros
        exploreOthersTitle: 'Explore Outros Efeitos de Vídeo Populares na WeryAI',
        aiDancing: 'Dança com IA',
        videoFaceSwap: 'Troca de Rostos em Vídeo com IA',
        videoToAnime: 'Vídeo para Anime com IA',
        videoUpscaler: 'Melhoramento de Vídeo',
        
        // Seção de introdução do modelo
        modelIntroTitle: 'Liberte Sua Criatividade e Comece a Criar Vídeos de Beijos Incríveis com WeryAI',
        modelIntroDescription: 'Experimente Nosso Gerador de Vídeos de Beijos com IA',
        modelIntroButtonText: 'Experimente Grátis o Gerador de Vídeos de Beijos da WeryAI',
        modelIntroFooterText: 'Não É Necessário Cartão de Crédito',
    },
    it: {
        // Titolo della pagina
        pageTitle: 'AI Kissing',
        previewTitle: 'Generatore di Video di Baci con IA',
        
        // Etichette
        labelType: 'Tipo',
        labelImage: 'Immagine',
        
        // Tipi
        typeFrenchKiss: 'Bacio Francese con IA',
        typeGeneral: 'Generale',
        typeKissMe: 'Baciami IA',
        typeCheekKiss: 'Bacio sulla Guancia',
        
        // Relativo al caricamento
        addImage: 'Aggiungi Immagine',
        clickToUpload: 'Clicca per caricare un\'immagine',
        uploading: 'Caricamento in corso...',
        
        // Opzioni di commutazione
        backgroundMusic: 'Musica di Sottofondo',
        publicVisibility: 'Rendi Pubblico',
        copyProtection: 'Protezione del Copyright',
        
        // Messaggi di tooltip
        backgroundMusicTooltip: 'Se abilitato, puoi scegliere tra le tracce musicali che abbiamo preparato per te da aggiungere al video generato.',
        publicVisibilityTooltip: 'Abilitando questa opzione, WeryAI può selezionare il tuo lavoro e pubblicarlo nel catalogo della comunità.',
        copyrightProtectionTooltip: 'Proteggi i tuoi immagini, video e suggerimenti caricati da non essere mostrati nella comunità. Una volta abilitato, altri utenti di WeryAI non potranno vedere le immagini, video e suggerimenti che hai caricato per generare questo contenuto nella comunità.',
        
        // Messaggi di avviso
        imageTip: 'Si prega di caricare un\'immagine contenente una o due persone. Il video genererà automaticamente un effetto di bacio.',
        maxTwoImages: 'Massimo 2 immagini consentite',
        pleaseSelectImage: 'Si prega di selezionare un file immagine',
        imageTooLarge: 'La dimensione dell\'immagine non deve superare i 100MB',
        uploadSuccess: 'Caricamento riuscito',
        uploadFailed: 'Caricamento fallito',
        noPreview: 'Nessun video di anteprima disponibile',
        
        // Messaggi di Errore e Stato
        errorNoImage: 'Si prega di caricare almeno un\'immagine',
        infoStart: 'Attività inviata con successo!',
        failedSubmit: 'Invio dell\'attività non riuscito',
        errorGeneral: 'Creazione del video non riuscita',
        
        // Informazioni sul pulsante
        btnInfo: 'Prova Gratis il Generatore di Video di Baci con IA',
        
        // Sezione introduzione
        introduceTitle: 'Generatore di Video di Baci con IA - Dai Vita a Due Foto con un Bacio',
        introduceDesc: 'Vuoi vedere il tuo idolo baciare un personaggio anime? O dare vita alle tue foto di coppia? Il Generatore di Video di Baci di WeryAI ha bisogno solo di due foto per creare video di baci realistici. Che si tratti di un romantico bacio francese, un dolce bacio sulla guancia o un giocoso bacio volante, l\'IA ricrea tutto perfettamente, abbattendo le barriere dimensionali con creatività!',
        
        // Sezione motivi
        selectReasonTitle: 'Perché Scegliere il Generatore di Video di Baci di WeryAI?',
        reason1Title: 'Movimento IA Ultra-Realistico, Fluido e Naturale',
        reason1Desc: 'Dì addio ai movimenti rigidi e robotici! Grazie agli algoritmi all\'avanguardia basati su immagini, WeryAI genera video di baci con movimenti della testa fluidi, microespressioni facciali naturali e texture della pelle realistiche, offrendo un\'esperienza visiva come se fossi davvero lì.',
        reason2Title: 'Modalità Multiple di Bacio, Personalizza il Tuo Romanticismo',
        reason2Desc: 'Da baci delicati a baci francesi appassionati e baci amorevoli sulla guancia. Puoi inserire liberamente prompt per controllare con precisione lo stile e l\'intensità del bacio, creando momenti intimi che corrispondono perfettamente alla tua immaginazione.',
        reason3Title: 'Tutto Può Baciare - Creatività Illimitata',
        reason3Desc: 'Liberati dalla realtà! Fai che due celebrità non correlate "si rendano pubbliche", fai che il tuo gatto e il tuo cane "si innamorino", o addirittura fai che una statua baci un personaggio di un dipinto. WeryAI supporta il mix di persone reali, anime, animali domestici, sculture e altro - perfetto per creare meme virali.',
        reason4Title: 'Attira Attenzione sui Social Media',
        reason4Desc: 'Stanco di testo e immagini semplici? Distinguiti su TikTok, Instagram o il tuo feed social con un video di baci con IA unico! Che si tratti di una confessione di vacanza, fare scherzi agli amici o creare materiali di marketing, questo è un modo completamente nuovo per catturare l\'attenzione istantaneamente.',
        
        // Sezione FAQ
        faqTitle: 'Domande Frequenti',
        faq1Question: 'Cos\'è un Generatore di Video di Baci con IA?',
        faq1Answer: 'È uno strumento IA che utilizza la tecnologia di deep learning per trasformare immagini statiche in video dinamici di baci. Basta caricare foto e WeryAI analizza le caratteristiche facciali per generare automaticamente animazioni fluide di due persone (o una persona e un oggetto) che si baciano. È ampiamente utilizzato per intrattenimento, condivisione sociale e produzione creativa.',
        faq2Question: 'Che tipo di video di baci posso creare?',
        faq2Answer: 'Quasi senza limiti! Puoi creare baci francesi romantici tra coppie, baci sulla guancia giocosi tra amici, o persino romanzi uomo-macchina trans-dimensionali. Finché hai creatività, l\'IA può aiutarti a realizzarla.',
        faq3Question: 'I video di baci generati sembrano realistici?',
        faq3Answer: 'Molto realistici. WeryAI utilizza modelli leader del settore basati su immagini che si concentrano sull\'ottimizzazione della logica fisica e della texture della pelle durante il contatto facciale, garantendo che i movimenti del bacio siano fluidi e naturali, riducendo notevolmente l\'effetto "uncanny valley" dei video IA tradizionali.',
        faq4Question: 'Posso usare gratuitamente il Generatore di Baci con IA?',
        faq4Answer: 'Sì! Forniamo punti di prova gratuiti in modo che ogni utente possa sperimentare il divertimento della creazione con IA. Puoi generare video e visualizzare in anteprima gli effetti gratuitamente, poi decidere se eseguire l\'upgrade per una qualità superiore.',
        faq5Question: 'La privacy delle mie foto è sicura?',
        faq5Answer: 'Assolutamente sicura. Prendiamo molto sul serio la tua privacy. Tutte le immagini caricate vengono utilizzate solo per la generazione video corrente e vengono automaticamente eliminate dai server dopo l\'elaborazione. Non verranno mai archiviate o utilizzate per altri scopi.',
        faq6Question: 'Quali formati di immagine sono supportati?',
        faq6Answer: 'Supportiamo formati di immagine comuni come JPG, PNG e WEBP. Per i migliori effetti di bacio, consigliamo di caricare foto con caratteristiche facciali chiare e buona illuminazione, con una risoluzione di almeno 512x512 pixel.',
        
        // Sezione come usare
        howToUseTitle: 'Come Usare il Nostro Generatore di Video di Baci con IA?',
        howToUseDesc: 'Tre passi per far innamorare le foto:',
        step1Title: 'Passo 1: Carica Foto',
        step1Desc: 'Scegli due foto di persone, animali domestici o personaggi che vuoi "abbinare" (funzionano sia ritratti singoli che foto di gruppo).',
        step2Title: 'Passo 2: Seleziona la Modalità',
        step2Desc: 'Scegli il tuo tipo di bacio desiderato (ad esempio, bacio francese, bacio sulla guancia, bacio sulla mano, ecc.), o inserisci un prompt personalizzato.',
        step3Title: 'Passo 3: Genera il Video',
        step3Desc: 'Clicca su genera e l\'IA farà la sua magia in pochi secondi, presentandoti un video di baci dolce o divertente!',
        
        // Sezione esplora altri
        exploreOthersTitle: 'Esplora Altri Effetti Video Popolari su WeryAI',
        aiDancing: 'Ballo con IA',
        videoFaceSwap: 'Scambio Volti Video con IA',
        videoToAnime: 'Video ad Anime con IA',
        videoUpscaler: 'Miglioramento Video',
        
        // Sezione introduzione del modello
        modelIntroTitle: 'Libera la Tua Creatività e Inizia a Creare Video di Baci Straordinari con WeryAI',
        modelIntroDescription: 'Prova il Nostro Generatore di Video di Baci con IA',
        modelIntroButtonText: 'Prova Gratis il Generatore di Video di Baci di WeryAI',
        modelIntroFooterText: 'Nessuna Carta di Credito Richiesta',
    },
    ar: {
        // عنوان الصفحة
        pageTitle: 'AI Kissing',
        previewTitle: 'مولد فيديو القبلات بالذكاء الاصطناعي',
        
        // التسميات
        labelType: 'النوع',
        labelImage: 'الصورة',
        
        // الأنواع
        typeFrenchKiss: 'قبلة فرنسية بالذكاء الاصطناعي',
        typeGeneral: 'عام',
        typeKissMe: 'قبلني بالذكاء الاصطناعي',
        typeCheekKiss: 'قبلة على الخد',
        
        // متعلق بالتحميل
        addImage: 'إضافة صورة',
        clickToUpload: 'انقر لتحميل صورة',
        uploading: 'جارٍ التحميل...',
        
        // خيارات التبديل
        backgroundMusic: 'موسيقى الخلفية',
        publicVisibility: 'جعله عاماً',
        copyProtection: 'حماية حقوق النشر',
        
        // رسائل التلميح
        backgroundMusicTooltip: 'إذا تم تفعيله، يمكنك الاختيار من بين المقاطع الموسيقية التي أعددناها لك لإضافتها إلى الفيديو المُنشأ.',
        publicVisibilityTooltip: 'بتفعيل هذه الخيار، يمكن لـ WeryAI تحديد العمل الخاص بك ونشره في قائمة المجتمع.',
        copyrightProtectionTooltip: 'يحمي الصور والفيديوهات والتلميحات التي تم تحميلها من عرضها في المجتمع. بمجرد تفعيل هذا الخيار، لن يتمكن المستخدمون الآخرون من WeryAI من رؤية الصور والفيديوهات والتلميحات التي قمت بتحميلها لإنشاء هذا المحتوى في المجتمع.',
        
        // رسائل التنبيه
        imageTip: 'يرجى تحميل صورة واحدة تحتوي على شخص واحد أو شخصين. سيُنشئ الفيديو تلقائيًا تأثير قبلة.',
        maxTwoImages: 'الحد الأقصى صورتان',
        pleaseSelectImage: 'يرجى تحديد ملف صورة',
        imageTooLarge: 'يجب ألا يتجاوز حجم الصورة 10 ميجابايت',
        uploadSuccess: 'تم التحميل بنجاح',
        uploadFailed: 'فشل التحميل',
        noPreview: 'لا يوجد فيديو معاينة متاح',
        
        // رسائل الخطأ والحالة
        errorNoImage: 'يرجى تحميل صورة واحدة على الأقل',
        infoStart: 'تم إرسال المهمة بنجاح!',
        failedSubmit: 'فشل في إرسال المهمة',
        errorGeneral: 'فشل في إنشاء الفيديو',
        
        // معلومات الزر
        btnInfo: 'جرب مولد فيديو القبلات بالذكاء الاصطناعي مجانًا',
        
        // قسم المقدمة
        introduceTitle: 'مولد فيديو القبلات بالذكاء الاصطناعي - أحيي صورتين بقبلة',
        introduceDesc: 'هل تريد رؤية معبودك يقبل شخصية أنمي؟ أو إحياء صور زوجك؟ يحتاج مولد فيديو القبلات من WeryAI صورتين فقط لإنشاء مقاطع فيديو قبلات واقعية. سواء كانت قبلة فرنسية رومانسية، أو قبلة حلوة على الخد، أو قبلة هوائية مرحة، يعيد الذكاء الاصطناعي إنشاء كل شيء بشكل مثالي، كاسرًا الحواجز البعدية بالإبداع!',
        
        // قسم الأسباب
        selectReasonTitle: 'لماذا تختار مولد فيديو القبلات من WeryAI؟',
        reason1Title: 'حركة ذكاء اصطناعي فائقة الواقعية، سلسة وطبيعية',
        reason1Desc: 'قل وداعًا للحركات الصلبة والروبوتية! بفضل الخوارزميات المتطورة المستندة إلى الصور، تولد WeryAI مقاطع فيديو قبلات بحركات رأس سلسة، وتعبيرات وجه دقيقة طبيعية، وأنسجة جلد واقعية، مما يوفر تجربة بصرية كما لو كنت هناك بالفعل.',
        reason2Title: 'أوضاع قبلة متعددة، خصص رومانسيتك',
        reason2Desc: 'من القبلات اللطيفة إلى القبلات الفرنسية الحماسية والقبلات المحبة على الخد. يمكنك إدخال المطالبات بحرية للتحكم بدقة في نمط وشدة القبلة، مما يخلق لحظات حميمة تتطابق تمامًا مع خيالك.',
        reason3Title: 'كل شيء يمكن أن يقبل - إبداع غير محدود',
        reason3Desc: 'تحرر من الواقع! اجعل مشهورين غير مرتبطين "يصبحون علنيين"، واجعل قطتك وكلبك "يقعان في الحب"، أو حتى اجعل تمثالًا يقبل شخصية لوحة. يدعم WeryAI مزج الأشخاص الحقيقيين والأنمي والحيوانات الأليفة والمنحوتات والمزيد - مثالي لإنشاء ميمات فيروسية.',
        reason4Title: 'جاذب الانتباه على وسائل التواصل الاجتماعي',
        reason4Desc: 'هل سئمت من النص والصور البسيطة؟ تميز على TikTok أو Instagram أو خلاصتك الاجتماعية بفيديو قبلة فريد بالذكاء الاصطناعي! سواء كان اعترافًا في عطلة، أو مقلب على الأصدقاء، أو إنشاء مواد تسويقية، هذه طريقة جديدة تمامًا لجذب الانتباه على الفور.',
        
        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو مولد فيديو القبلات بالذكاء الاصطناعي؟',
        faq1Answer: 'إنها أداة ذكاء اصطناعي تستخدم تقنية التعلم العميق لتحويل الصور الثابتة إلى مقاطع فيديو قبلات ديناميكية. ما عليك سوى تحميل الصور، وسيقوم WeryAI بتحليل ملامح الوجه لتوليد رسوم متحركة سلسة تلقائيًا لشخصين (أو شخص وكائن) يقبلان. يُستخدم على نطاق واسع للترفيه والمشاركة الاجتماعية والإنتاج الإبداعي.',
        faq2Question: 'ما نوع مقاطع فيديو القبلات التي يمكنني إنشاؤها؟',
        faq2Answer: 'تقريبًا بلا حدود! يمكنك إنشاء قبلات فرنسية رومانسية بين الأزواج، أو قبلات على الخد مرحة بين الأصدقاء، أو حتى رومانسية إنسان-آلة عبر الأبعاد. طالما لديك إبداع، يمكن للذكاء الاصطناعي مساعدتك في تحقيقه.',
        faq3Question: 'هل تبدو مقاطع فيديو القبلات المولدة واقعية؟',
        faq3Answer: 'واقعية جدًا. يستخدم WeryAI نماذج رائدة في الصناعة مستندة إلى الصور تركز على تحسين المنطق الفيزيائي ونسيج الجلد أثناء ملامسة الوجه، مما يضمن أن تكون حركات القبلة سلسة وطبيعية، مما يقلل بشكل كبير من تأثير "الوادي المخيف" لمقاطع الفيديو التقليدية بالذكاء الاصطناعي.',
        faq4Question: 'هل يمكنني استخدام مولد القبلات بالذكاء الاصطناعي مجانًا؟',
        faq4Answer: 'نعم! نوفر نقاط تجريبية مجانية حتى يتمكن كل مستخدم من تجربة متعة الإنشاء بالذكاء الاصطناعي. يمكنك إنشاء مقاطع فيديو ومعاينة التأثيرات مجانًا، ثم تقرر ما إذا كنت تريد الترقية لجودة أعلى.',
        faq5Question: 'هل خصوصية صوري آمنة؟',
        faq5Answer: 'آمنة تمامًا. نأخذ خصوصيتك على محمل الجد. يتم استخدام جميع الصور المحملة فقط لتوليد الفيديو الحالي ويتم حذفها تلقائيًا من الخوادم بعد المعالجة. لن يتم تخزينها أو استخدامها لأغراض أخرى أبدًا.',
        faq6Question: 'ما هي تنسيقات الصور المدعومة؟',
        faq6Answer: 'ندعم تنسيقات الصور الرئيسية مثل JPG و PNG و WEBP. للحصول على أفضل تأثيرات القبلة، نوصي بتحميل صور ذات ملامح وجه واضحة وإضاءة جيدة، بدقة لا تقل عن 512x512 بكسل.',
        
        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية استخدام مولد فيديو القبلات بالذكاء الاصطناعي؟',
        howToUseDesc: 'ثلاث خطوات لجعل الصور تقع في الحب:',
        step1Title: 'الخطوة 1: تحميل الصور',
        step1Desc: 'اختر صورتين للأشخاص أو الحيوانات الأليفة أو الشخصيات التي تريد "مطابقتها" (تعمل الصور الفردية أو الصور الجماعية).',
        step2Title: 'الخطوة 2: حدد الوضع',
        step2Desc: 'اختر نوع القبلة المطلوب (على سبيل المثال، قبلة فرنسية، قبلة على الخد، قبلة على اليد، إلخ)، أو أدخل مطالبة مخصصة.',
        step3Title: 'الخطوة 3: إنشاء الفيديو',
        step3Desc: 'انقر فوق إنشاء، وسيقوم الذكاء الاصطناعي بسحره في ثوانٍ، ليقدم لك فيديو قبلة حلو أو مضحك!',
        
        // قسم استكشاف أخرى
        exploreOthersTitle: 'استكشف تأثيرات الفيديو الشائعة الأخرى على WeryAI',
        aiDancing: 'الرقص بالذكاء الاصطناعي',
        videoFaceSwap: 'مبادلة الوجوه في الفيديو بالذكاء الاصطناعي',
        videoToAnime: 'فيديو إلى أنمي بالذكاء الاصطناعي',
        videoUpscaler: 'تحسين الفيديو',
        
        // قسم مقدمة النموذج
        modelIntroTitle: 'أطلق العنان لإبداعك وابدأ في إنشاء مقاطع فيديو قبلات مذهلة مع WeryAI',
        modelIntroDescription: 'جرب مولد فيديو القبلات بالذكاء الاصطناعي الخاص بنا',
        modelIntroButtonText: 'جرب مولد فيديو القبلات من WeryAI مجانًا',
        modelIntroFooterText: 'لا حاجة لبطاقة ائتمان',
    },
    tw: {
        // 頁面標題
        pageTitle: 'AI 親吻',
        previewTitle: 'AI 親吻影片產生器',
        
        // 標籤
        labelType: '類型',
        labelImage: '圖片',
        
        // 類型種類
        typeFrenchKiss: 'AI 法式親吻',
        typeGeneral: '一般',
        typeKissMe: '吻我 AI',
        typeCheekKiss: '親吻臉頰',
        
        // 上傳相關
        addImage: '新增圖片',
        clickToUpload: '點擊上傳圖片',
        uploading: '上傳中...',
        
        // 開關選項
        backgroundMusic: '背景音樂',
        publicVisibility: '公開可見',
        copyProtection: '版權保護',
        
        // 工具提示訊息
        backgroundMusicTooltip: '啟用後，您可以從我們為您準備的音樂曲目中選擇，添加到產生的影片中。',
        publicVisibilityTooltip: '開啟此選項後，WeryAI 可能會選中您的作品並將其發布到社群目錄。',
        copyrightProtectionTooltip: '保護您上傳的圖片、影片和提示詞不被展示在社群中。一旦啟用此選項，其他 WeryAI 用戶將無法在社群中看到您為產生此內容上傳的圖片、影片和提示詞。',
        
        // 提示訊息
        imageTip: '請上傳一張包含一個或兩個人的圖片。影片會自動產生接吻影片效果。',
        maxTwoImages: '最多只能上傳 2 張圖片',
        pleaseSelectImage: '請選擇圖片檔案',
        imageTooLarge: '圖片大小不能超過 100MB',
        uploadSuccess: '上傳成功',
        uploadFailed: '上傳失敗',
        noPreview: '暫無預覽影片',
        
        // 錯誤與狀態訊息
        errorNoImage: '請至少上傳一張圖片',
        infoStart: '任務已成功提交！',
        failedSubmit: '提交任務失敗',
        errorGeneral: '建立影片失敗',
        
        // 按鈕資訊
        btnInfo: '免費試用 AI 親吻影片產生器',
        
        // 介紹部分
        introduceTitle: 'AI 親吻影片產生器 - 用親吻賦予兩張照片生命',
        introduceDesc: '想看您的偶像和二次元角色親吻？或者讓您和愛人的合照動起來？WeryAI 親吻影片產生器，只需兩張照片，即可產生逼真的接吻影片。無論是浪漫的法式親吻、甜美的親吻臉頰，還是俏皮的飛吻，AI 都能完美重現，用創意突破次元壁！',
        
        // 選擇理由部分
        selectReasonTitle: '為什麼選擇 WeryAI 親吻影片產生器？',
        reason1Title: '超逼真 AI 動作，絲滑自然',
        reason1Desc: '拒絕機械般的生硬動作！得益於最先進的圖像驅動演算法，WeryAI 產生的親吻影片擁有流暢的頭部運動、自然的面部微表情和真實的皮膚紋理，帶來身臨其境的視覺體驗。',
        reason2Title: '多種親吻模式，定制專屬浪漫',
        reason2Desc: '從溫柔的淺嚐輒止，到熱烈的法式濕吻，再到充滿愛意的親吻臉頰。您可以自由輸入提示語，精準控制親吻的風格和強度，創造完全符合您想像的親密時刻。',
        reason3Title: '萬物皆可「吻」- 創意無極限',
        reason3Desc: '打破現實束縛！您可以讓兩個毫不相干的名人「官宣」，讓家裡的貓咪和狗狗「相親相愛」，甚至讓雕像與畫中人「墜入愛河」。WeryAI 支持真人、動漫、寵物、雕塑等混搭，是製作病毒式社群內容的絕佳工具。',
        reason4Title: '社群媒體吸睛利器',
        reason4Desc: '厭倦了平淡的圖文？用一個獨特的 AI 親吻影片在 TikTok、Instagram 或動態中脫穎而出！無論是節日告白、朋友惡搞還是創作營銷素材，這都是瞬間抓住眼球的新方式。',
        
        // 常見問題部分
        faqTitle: '常見問題解答',
        faq1Question: '什麼是 AI 親吻影片產生器？',
        faq1Answer: '它是一款利用深度學習技術，將靜態圖片轉化為動態親吻影片的 AI 工具。只需上傳照片，WeryAI 就會分析面部特徵，自動產生兩個人（或人與物體）親吻的流暢動畫。廣泛用於娛樂、社群分享和創意製作。',
        faq2Question: '我可以製作什麼樣的親吻影片？',
        faq2Answer: '幾乎沒有任何限制！您可以製作情侶間的浪漫法式親吻、朋友間的玩笑親臉頰，甚至是跨越次元的人機之戀。只要您有創意，AI 就能幫您實現。',
        faq3Question: '產生的親吻影片看起來真實嗎？',
        faq3Answer: '非常真實. WeryAI 採用行業領先的圖像驅動模型，專注於優化面部接觸時的物理邏輯和皮膚質感，確保親吻動作既絲滑又自然，大大降低了傳統 AI 影片的「恐怖谷」效應。',
        faq4Question: '我可以免費使用 AI 親吻產生器嗎？',
        faq4Answer: '是的！我們提供免費試用點數，讓每位用戶都能體驗 AI 創作的樂趣。您可以免費產生影片並預覽效果，然後再決定是否升級以獲取更高畫質。',
        faq5Question: '我的照片隱私安全嗎？',
        faq5Answer: '絕對安全。我們非常重視您的隱私。所有上傳的圖片僅用於當前影片產生，處理完成後會自動從伺服器刪除。它們絕不會被存儲或用於其他用途。',
        faq6Question: '支持哪些圖片格式？',
        faq6Answer: '我們支持 JPG、PNG 和 WEBP 等主流圖片格式。為了獲得最佳親吻效果，建議上傳面部特徵清晰、光線良好的照片，解析度至少為 512x512 像素。',
        
        // 使用方法部分
        howToUseTitle: '如何使用我們的 AI 親吻影片產生器？',
        howToUseDesc: '三步讓照片「談戀愛」：',
        step1Title: '步驟 1：上傳照片',
        step1Desc: '選擇兩張您想要「配對」的人物、寵物或角色照片（單人肖像或合照均可）。',
        step2Title: '步驟 2：選擇模式',
        step2Desc: '選擇您想要的親吻類型（如法式親吻、親吻臉頰、親吻手背等），或輸入自定義提示語。',
        step3Title: '步驟 3：產生影片',
        step3Desc: '點擊產生，AI 將在幾秒鐘內施展魔法，為您呈現一段甜蜜或有趣的親吻影片！',
        
        // 探索其他部分
        exploreOthersTitle: '在 WeryAI 探索其他熱門影片特效',
        aiDancing: 'AI 舞蹈',
        videoFaceSwap: 'AI 影片換臉',
        videoToAnime: 'AI 影片動漫轉換',
        videoUpscaler: '影片增強',
        
        // 模型介紹部分
        modelIntroTitle: '釋放您的創意，開始使用 WeryAI 創作令人驚嘆的親吻影片',
        modelIntroDescription: '嘗試我們的 AI 親吻影片產生器',
        modelIntroButtonText: '免費試用 WeryAI 親吻影片產生器',
        modelIntroFooterText: '無需信用卡',
    },
    pl: {
        pageTitle: 'AI Kissing',
        previewTitle: 'Generator wideo pocałunków AI',
        labelType: 'Typ',
        labelImage: 'Obraz',
        typeFrenchKiss: 'Francuski pocałunek AI',
        typeGeneral: 'Ogólny',
        typeKissMe: 'Pocałuj mnie AI',
        typeCheekKiss: 'Pocałunek w policzek',
        addImage: 'Dodaj obraz',
        clickToUpload: 'Kliknij, aby przesłać obraz',
        uploading: 'Przesyłanie...',
        backgroundMusic: 'Muzyka w tle',
        publicVisibility: 'Upublicznij',
        copyProtection: 'Ochrona praw autorskich',
        backgroundMusicTooltip: 'Po włączeniu możesz wybrać spośród przygotowanych przez nas utworów muzycznych do dodania do wygenerowanego wideo.',
        publicVisibilityTooltip: 'Włączając tę opcję, WeryAI może wybrać twoją pracę i opublikować ją w katalogu społeczności.',
        copyrightProtectionTooltip: 'Chroni przesłane obrazy, filmy i podpowiedzi przed wyświetlaniem w społeczności.',
        imageTip: 'Prześlij jedno zdjęcie zawierające jedną lub dwie osoby. Wideo automatycznie wygeneruje efekt pocałunku.',
        maxTwoImages: 'Maksymalnie 2 obrazy dozwolone',
        pleaseSelectImage: 'Wybierz plik obrazu',
        imageTooLarge: 'Rozmiar obrazu nie powinien przekraczać 100 MB',
        uploadSuccess: 'Przesyłanie zakończone sukcesem',
        uploadFailed: 'Przesyłanie nie powiodło się',
        noPreview: 'Brak podglądu wideo',
        errorNoImage: 'Prześlij co najmniej jeden obraz',
        infoStart: 'Zadanie przesłane pomyślnie!',
        failedSubmit: 'Nie udało się przesłać zadania',
        errorGeneral: 'Nie udało się utworzyć wideo',
        btnInfo: 'Wypróbuj generator wideo pocałunków AI za darmo',
        introduceTitle: 'Generator wideo pocałunków AI - ożyw dwa zdjęcia pocałunkiem',
        introduceDesc: 'Chcesz zobaczyć, jak twój idol całuje postać z anime? Lub ożywić zdjęcia pary? Generator wideo pocałunków WeryAI potrzebuje tylko dwóch zdjęć, aby stworzyć realistyczne filmy z pocałunkami.',
        selectReasonTitle: 'Dlaczego wybrać generator wideo pocałunków WeryAI?',
        reason1Title: 'Ultra-realistyczny ruch AI, płynny i naturalny',
        reason1Desc: 'Pożegnaj sztywne, robotyczne ruchy! Dzięki najnowocześniejszym algorytmom opartym na obrazach, WeryAI generuje filmy z pocałunkami z płynnymi ruchami głowy i naturalnymi mikroekspresjami twarzy.',
        reason2Title: 'Wiele trybów pocałunków, dostosuj swój romans',
        reason2Desc: 'Od delikatnych pocałunków po namiętne francuskie pocałunki i czułe pocałunki w policzek. Możesz swobodnie wprowadzać podpowiedzi, aby precyzyjnie kontrolować styl i intensywność pocałunku.',
        reason3Title: 'Wszystko może się całować - nieograniczona kreatywność',
        reason3Desc: 'Uwolnij się od rzeczywistości! Spraw, by dwie niezwiązane ze sobą celebrytki "wyszły na jaw", pozwól swojemu kotu i psu "zakochać się".',
        reason4Title: 'Przyciągacz uwagi w mediach społecznościowych',
        reason4Desc: 'Masz dość zwykłego tekstu i obrazów? Wyróżnij się na TikToku, Instagramie lub w swoim kanale społecznościowym unikalnym filmem z pocałunkiem AI!',
        faqTitle: 'Często zadawane pytania',
        faq1Question: 'Czym jest generator wideo pocałunków AI?',
        faq1Answer: 'To narzędzie AI, które wykorzystuje technologię głębokiego uczenia do przekształcania statycznych obrazów w dynamiczne filmy z pocałunkami.',
        faq2Question: 'Jakie filmy z pocałunkami mogę tworzyć?',
        faq2Answer: 'Prawie bez ograniczeń! Możesz tworzyć romantyczne francuskie pocałunki między parami, zabawne pocałunki w policzek między przyjaciółmi.',
        faq3Question: 'Czy wygenerowane filmy z pocałunkami wyglądają realistycznie?',
        faq3Answer: 'Bardzo realistycznie. WeryAI wykorzystuje wiodące w branży modele oparte na obrazach, które koncentrują się na optymalizacji logiki fizycznej i tekstury skóry podczas kontaktu twarzy.',
        faq4Question: 'Czy mogę używać generatora pocałunków AI za darmo?',
        faq4Answer: 'Tak! Zapewniamy darmowe punkty próbne, aby każdy użytkownik mógł doświadczyć zabawy z tworzeniem AI.',
        faq5Question: 'Czy prywatność moich zdjęć jest bezpieczna?',
        faq5Answer: 'Absolutnie bezpieczna. Traktujemy twoją prywatność bardzo poważnie. Wszystkie przesłane obrazy są używane tylko do bieżącej generacji wideo i są automatycznie usuwane z serwerów po przetworzeniu.',
        faq6Question: 'Jakie formaty obrazów są obsługiwane?',
        faq6Answer: 'Obsługujemy popularne formaty obrazów, takie jak JPG, PNG i WEBP.',
        howToUseTitle: 'Jak używać naszego generatora wideo pocałunków AI?',
        howToUseDesc: 'Trzy kroki, aby zdjęcia się zakochały:',
        step1Title: 'Krok 1: Prześlij zdjęcia',
        step1Desc: 'Wybierz dwa zdjęcia osób, zwierząt lub postaci, które chcesz "połączyć".',
        step2Title: 'Krok 2: Wybierz tryb',
        step2Desc: 'Wybierz żądany typ pocałunku lub wprowadź niestandardową podpowiedź.',
        step3Title: 'Krok 3: Wygeneruj wideo',
        step3Desc: 'Kliknij generuj, a AI wykona swoją magię w kilka sekund, prezentując ci słodki lub zabawny film z pocałunkiem!',
        exploreOthersTitle: 'Odkryj inne popularne efekty wideo na WeryAI',
        aiDancing: 'Taniec AI',
        videoFaceSwap: 'Zamiana twarzy w wideo AI',
        videoToAnime: 'Wideo do anime AI',
        videoUpscaler: 'Ulepszanie wideo',
        modelIntroTitle: 'Uwolnij swoją kreatywność i zacznij tworzyć niesamowite filmy z pocałunkami z WeryAI',
        modelIntroDescription: 'Wypróbuj nasz generator wideo pocałunków AI',
        modelIntroButtonText: 'Wypróbuj generator wideo pocałunków WeryAI za darmo',
        modelIntroFooterText: 'Nie wymaga karty kredytowej',
    },
    th: {
        // Page Title
        pageTitle: 'AI จูบ',
        previewTitle: 'เครื่องมือสร้างวิดีโอจูบด้วย AI',
        
        // Labels
        labelType: 'ประเภท',
        labelImage: 'รูปภาพ',
        
        // Type Types
        typeFrenchKiss: 'จูบแบบฝรั่งเศสด้วย AI',
        typeGeneral: 'ทั่วไป',
        typeKissMe: 'Kiss Me AI',
        typeCheekKiss: 'จูบแก้ม',
        
        // Upload Related
        addImage: 'เพิ่มรูปภาพ',
        clickToUpload: 'คลิกเพื่ออัปโหลดรูปภาพ',
        uploading: 'กำลังอัปโหลด...',
        
        // Switch Options
        backgroundMusic: 'เพลงพื้นหลัง',
        publicVisibility: 'ตั้งเป็นสาธารณะ',
        copyProtection: 'การป้องกันลิขสิทธิ์',
        
        // Tooltip Messages
        backgroundMusicTooltip: 'หากเปิดใช้งาน คุณสามารถเลือกเพลงจากรายการที่เราจัดเตรียมไว้เพื่อใส่ลงในวิดีโอที่สร้างได้',
        publicVisibilityTooltip: 'เมื่อเปิดตัวเลือกนี้ WeryAI อาจคัดเลือกผลงานของคุณและเผยแพร่ในไดเรกทอรีชุมชน',
        copyrightProtectionTooltip: 'ปกป้องรูปภาพ วิดีโอ และพรอมป์ต์ที่อัปโหลดของคุณไม่ให้แสดงในชุมชน เมื่อเปิดใช้งาน ผู้ใช้ WeryAI คนอื่นจะไม่สามารถเห็นรูปภาพ วิดีโอ และพรอมป์ต์ที่คุณอัปโหลดเพื่อสร้างเนื้อหานี้ได้',
        
        // Prompt Messages
        imageTip: 'โปรดอัปโหลดรูปภาพที่มีคนหนึ่งหรือสองคน วิดีโอจะสร้างเอฟเฟกต์จูบโดยอัตโนมัติ',
        maxTwoImages: 'อนุญาตสูงสุด 2 รูป',
        pleaseSelectImage: 'โปรดเลือกไฟล์รูปภาพ',
        imageTooLarge: 'ขนาดรูปภาพต้องไม่เกิน 100MB',
        uploadSuccess: 'อัปโหลดสำเร็จ',
        uploadFailed: 'อัปโหลดล้มเหลว',
        noPreview: 'ไม่มีวิดีโอตัวอย่าง',
        
        // Error and Status Messages
        errorNoImage: 'โปรดอัปโหลดอย่างน้อยหนึ่งรูป',
        infoStart: 'ส่งงานสำเร็จ!',
        failedSubmit: 'ส่งงานไม่สำเร็จ',
        errorGeneral: 'สร้างวิดีโอไม่สำเร็จ',
        
        // Button Info
        btnInfo: 'ทดลองใช้ฟรี AI Kissing Video Generator',
        
        // Introduction Section
        introduceTitle: 'AI Kissing Video Generator - ทำให้สองรูปมีชีวิตด้วยการจูบ',
        introduceDesc: 'อยากเห็นไอดอลจูบตัวละครอนิเมะไหม? หรืออยากให้รูปคู่มีชีวิตขึ้นมา? เครื่องมือจูบวิดีโอของ WeryAI ใช้เพียงสองรูปก็สร้างวิดีโอจูบที่สมจริงได้ ไม่ว่าจะเป็นจูบฝรั่งเศสสุดโรแมนติก จูบแก้มหวานๆ หรือจูบลมแบบขี้เล่น AI ก็ถ่ายทอดได้หมด ทลายกำแพงมิติด้วยความคิดสร้างสรรค์!',
        
        // Reason Selection Section
        selectReasonTitle: 'ทำไมต้องเลือก WeryAI Kissing Video Generator?',
        reason1Title: 'โมชั่น AI สมจริง ลื่นไหลเป็นธรรมชาติ',
        reason1Desc: 'บอกลาการเคลื่อนไหวแข็งทื่อเหมือนหุ่นยนต์! ด้วยอัลกอริทึมขับเคลื่อนด้วยภาพที่ล้ำสมัย WeryAI สร้างวิดีโอจูบที่มีการเคลื่อนไหวศีรษะลื่นไหล สีหน้าจิ๋วที่เป็นธรรมชาติ และผิวที่สมจริง ให้ประสบการณ์ที่เหมือนอยู่ตรงนั้นจริงๆ',
        reason2Title: 'โหมดจูบหลากหลาย ปรับแต่งความโรแมนติกได้เอง',
        reason2Desc: 'ตั้งแต่จุ๊บเบาๆ ไปจนถึงจูบฝรั่งเศสสุดเร่าร้อนและจูบแก้มอบอุ่น คุณสามารถใส่พรอมป์ต์ได้อย่างอิสระเพื่อควบคุมสไตล์และความเข้มข้นของการจูบ สร้างช่วงเวลาใกล้ชิดที่ตรงกับจินตนาการของคุณ',
        reason3Title: 'ทุกอย่างจูบได้ ไอเดียไร้ขีดจำกัด',
        reason3Desc: 'หลุดพ้นจากกรอบความจริง! ให้คนดังที่ไม่เกี่ยวกัน “เปิดตัว” ให้แมวกับสุนัข “ตกหลุมรัก” หรือแม้แต่ให้รูปปั้นจูบตัวละครในภาพวาด WeryAI รองรับคนจริง อนิเมะ สัตว์เลี้ยง งานประติมากรรม ฯลฯ เหมาะกับการทำมีมไวรัล',
        reason4Title: 'เครื่องมือดึงดูดสายตาบนโซเชียล',
        reason4Desc: 'เบื่อข้อความและรูปภาพธรรมดาๆ แล้วใช่ไหม? โดดเด่นบน TikTok, Instagram หรือฟีดโซเชียลด้วยวิดีโอจูบ AI ที่ไม่เหมือนใคร ไม่ว่าจะเป็นสารภาพรักช่วงเทศกาล แกล้งเพื่อน หรือทำสื่อการตลาด นี่คือวิธีใหม่ที่ดึงดูดสายตาได้ทันที',
        
        // FAQ Section
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question: 'AI Kissing Video Generator คืออะไร?',
        faq1Answer: 'เป็นเครื่องมือ AI ที่ใช้เทคโนโลยีดีปเลิร์นนิงแปลงภาพนิ่งเป็นวิดีโอจูบแบบเคลื่อนไหว เพียงอัปโหลดรูป WeryAI จะวิเคราะห์ใบหน้าและสร้างแอนิเมชันการจูบของคนสองคน (หรือคนกับวัตถุ) อย่างลื่นไหล ใช้กันอย่างแพร่หลายสำหรับความบันเทิง การแชร์โซเชียล และงานสร้างสรรค์',
        faq2Question: 'ฉันสร้างวิดีโอจูบแบบไหนได้บ้าง?',
        faq2Answer: 'แทบไม่มีข้อจำกัด! คุณสามารถสร้างจูบฝรั่งเศสสุดโรแมนติกระหว่างคู่รัก จูบแก้มแบบขี้เล่นระหว่างเพื่อน หรือแม้แต่รักข้ามมิติคนกับเครื่องจักร แค่มีไอเดีย AI ก็ช่วยทำให้เป็นจริงได้',
        faq3Question: 'วิดีโอจูบที่สร้างออกมาดูสมจริงไหม?',
        faq3Answer: 'สมจริงมาก WeryAI ใช้โมเดลขับเคลื่อนด้วยภาพระดับแนวหน้าที่โฟกัสการปรับตรรกะทางฟิสิกส์และพื้นผิวผิวหนังระหว่างการสัมผัสใบหน้า ทำให้การจูบลื่นไหลเป็นธรรมชาติ ลดเอฟเฟกต์ “uncanny valley” ของวิดีโอ AI แบบเดิมอย่างมาก',
        faq4Question: 'สามารถใช้ AI Kissing Generator ได้ฟรีไหม?',
        faq4Answer: 'ได้! เรามีคะแนนทดลองใช้ฟรีเพื่อให้ทุกคนได้สัมผัสความสนุกของการสร้างสรรค์ด้วย AI คุณสามารถสร้างวิดีโอและพรีวิวเอฟเฟกต์ได้ฟรี แล้วค่อยตัดสินใจอัปเกรดเพื่อคุณภาพที่สูงขึ้น',
        faq5Question: 'ความเป็นส่วนตัวของรูปภาพฉันปลอดภัยไหม?',
        faq5Answer: 'ปลอดภัยอย่างยิ่ง เราให้ความสำคัญกับความเป็นส่วนตัวอย่างจริงจัง รูปภาพที่อัปโหลดจะถูกใช้เฉพาะการสร้างวิดีโอครั้งนี้และถูกลบจากเซิร์ฟเวอร์โดยอัตโนมัติหลังประมวลผล ไม่ถูกเก็บหรือใช้เพื่อวัตถุประสงค์อื่น',
        faq6Question: 'รองรับไฟล์รูปภาพรูปแบบใดบ้าง?',
        faq6Answer: 'รองรับรูปแบบยอดนิยม เช่น JPG, PNG และ WEBP เพื่อผลลัพธ์ที่ดีที่สุด แนะนำให้อัปโหลดรูปที่ใบหน้าชัดและแสงดี โดยความละเอียดอย่างน้อย 512x512 พิกเซล',
        
        // How to Use Section
        howToUseTitle: 'วิธีใช้ AI Kissing Video Generator ของเรา?',
        howToUseDesc: 'สามขั้นตอนให้รูปภาพตกหลุมรักกัน:',
        step1Title: 'ขั้นตอนที่ 1: อัปโหลดรูปภาพ',
        step1Desc: 'เลือกสองรูปของคน สัตว์เลี้ยง หรือคาแรกเตอร์ที่คุณอยาก “จับคู่” (รูปเดี่ยวหรือรูปกลุ่มก็ได้)',
        step2Title: 'ขั้นตอนที่ 2: เลือกโหมด',
        step2Desc: 'เลือกประเภทการจูบที่ต้องการ (เช่น จูบฝรั่งเศส จูบแก้ม จูบมือ ฯลฯ) หรือใส่พรอมป์ต์เอง',
        step3Title: 'ขั้นตอนที่ 3: สร้างวิดีโอ',
        step3Desc: 'คลิกสร้าง แล้ว AI จะร่ายเวทในไม่กี่วินาที ส่งวิดีโอจูบหวานๆ หรือขำๆ ให้คุณ!',
        
        // Explore Others Section
        exploreOthersTitle: 'สำรวจเอฟเฟกต์วิดีโอยอดนิยมอื่น ๆ ที่ WeryAI',
        aiDancing: 'AI เต้น',
        videoFaceSwap: 'สลับใบหน้าในวิดีโอด้วย AI',
        videoToAnime: 'แปลงวิดีโอเป็นอนิเมะด้วย AI',
        videoUpscaler: 'ปรับปรุงวิดีโอ',
        
        // Model Introduction Section
        modelIntroTitle: 'ปลดปล่อยความคิดสร้างสรรค์และเริ่มทำวิดีโอจูบสุดมหัศจรรย์กับ WeryAI',
        modelIntroDescription: 'ลองใช้ AI Kissing Video Generator ของเรา',
        modelIntroButtonText: 'ทดลองใช้ฟรี WeryAI Kissing Video Generator',
        modelIntroFooterText: 'ไม่ต้องใช้บัตรเครดิต',
    },
    da: {
        // Page Title
        pageTitle: 'AI Kys',
        previewTitle: 'AI Kys-video generator',
        
        // Labels
        labelType: 'Type',
        labelImage: 'Billede',
        
        // Type Types
        typeFrenchKiss: 'AI fransk kys',
        typeGeneral: 'Generel',
        typeKissMe: 'Kiss Me AI',
        typeCheekKiss: 'Kys på kinden',
        
        // Upload Related
        addImage: 'Tilføj billede',
        clickToUpload: 'Klik for at uploade et billede',
        uploading: 'Uploader...',
        
        // Switch Options
        backgroundMusic: 'Baggrundsmusik',
        publicVisibility: 'Gør offentlig',
        copyProtection: 'Ophavsretsbeskyttelse',
        
        // Tooltip Messages
        backgroundMusicTooltip: 'Hvis aktiveret kan du vælge blandt musiksporene, vi har forberedt, og tilføje dem til den genererede video.',
        publicVisibilityTooltip: 'Når du aktiverer denne mulighed, kan WeryAI udvælge dit værk og publicere det i community-kataloget.',
        copyrightProtectionTooltip: 'Beskyt dine uploadede billeder, videoer og prompts mod at blive vist i communityet. Når den er aktiveret, kan andre WeryAI-brugere ikke se de billeder, videoer og prompts, du uploadede for at skabe dette indhold i communityet.',
        
        // Prompt Messages
        imageTip: 'Upload venligst et billede med en eller to personer. Videoen genererer automatisk en kysseffekt.',
        maxTwoImages: 'Maks. 2 billeder tilladt',
        pleaseSelectImage: 'Vælg venligst en billedfil',
        imageTooLarge: 'Billedstørrelsen må ikke overstige 100 MB',
        uploadSuccess: 'Upload lykkedes',
        uploadFailed: 'Upload mislykkedes',
        noPreview: 'Ingen forhåndsvisning tilgængelig',
        
        // Error and Status Messages
        errorNoImage: 'Upload mindst ét billede',
        infoStart: 'Opgaven blev sendt!',
        failedSubmit: 'Kunne ikke sende opgaven',
        errorGeneral: 'Kunne ikke oprette video',
        
        // Button Info
        btnInfo: 'Prøv AI Kys-video generator gratis',
        
        // Introduction Section
        introduceTitle: 'AI Kys-video generator - giv to billeder liv med et kys',
        introduceDesc: 'Vil du se din idol kysse en animefigur? Eller give jeres parbilleder liv? WeryAI Kys-video generator skal kun bruge to fotos for at skabe realistiske kyssevideoer. Uanset om det er et romantisk fransk kys, et sødt kindkys eller et legende luftkys, genskaber AI det hele og bryder dimensionsgrænser med kreativitet!',
        
        // Reason Selection Section
        selectReasonTitle: 'Hvorfor vælge WeryAI Kys-video generator?',
        reason1Title: 'Ultra-realistisk AI-bevægelse, glat og naturlig',
        reason1Desc: 'Sig farvel til stive, robotagtige bevægelser! Takket være banebrydende billeddrevne algoritmer skaber WeryAI kyssevideoer med flydende hovedbevægelser, naturlige mikroansigtsudtryk og realistiske hudteksturer – en visuel oplevelse, der føles som at være der selv.',
        reason2Title: 'Flere kyssetilstande, tilpas din romance',
        reason2Desc: 'Fra blide kindkys til passionerede franske kys. Du kan frit angive prompts for præcist at styre stil og intensitet og skabe intime øjeblikke, der matcher din fantasi.',
        reason3Title: 'Alt kan kysse - ubegrænset kreativitet',
        reason3Desc: 'Slip fri af virkeligheden! Lad to uvedkommende kendisser "gå public", få din kat og hund til at "forelske sig", eller lad en statue kysse en figur fra et maleri. WeryAI understøtter blanding af rigtige mennesker, anime, kæledyr, skulpturer og mere – perfekt til virale memes.',
        reason4Title: 'Fang opmærksomheden på sociale medier',
        reason4Desc: 'Træt af almindelig tekst og billeder? Skil dig ud på TikTok, Instagram eller dit feed med en unik AI-kyssevideo! Uanset om det er en ferieerklæring, en prank på venner eller marketingmateriale, er dette en helt ny måde at fange opmærksomheden på.',
        
        // FAQ Section
        faqTitle: 'Ofte stillede spørgsmål',
        faq1Question: 'Hvad er en AI Kys-video generator?',
        faq1Answer: 'Det er et AI-værktøj, der bruger deep learning til at omdanne statiske billeder til dynamiske kyssevideoer. Upload blot fotos, så analyserer WeryAI ansigtstræk og genererer glatte animationer af to personer (eller en person og en genstand) der kysser. Det bruges bredt til underholdning, social deling og kreativ produktion.',
        faq2Question: 'Hvilke typer kyssevideoer kan jeg lave?',
        faq2Answer: 'Næsten ingen grænser! Du kan skabe romantiske franske kys mellem par, sjove kindkys mellem venner eller endda kærlighed på tværs af dimensioner. Så længe du har kreativiteten, kan AI hjælpe dig.',
        faq3Question: 'Ser de genererede kyssevideoer realistiske ud?',
        faq3Answer: 'Meget realistiske. WeryAI bruger brancheførende billeddrevne modeller, der fokuserer på at optimere fysiklogik og hudtekstur ved ansigtskontakt, så kyssebevægelserne bliver både glatte og naturlige og reducerer "uncanny valley"-effekten markant.',
        faq4Question: 'Kan jeg bruge AI Kys-generatoren gratis?',
        faq4Answer: 'Ja! Vi tilbyder gratis prøvepoint, så alle kan opleve glæden ved AI-skabelse. Du kan generere videoer og forhåndsvise effekter gratis og derefter beslutte, om du vil opgradere til højere kvalitet.',
        faq5Question: 'Er mine fotos privatliv sikre?',
        faq5Answer: 'Helt sikkert. Vi tager dit privatliv alvorligt. Alle uploadede billeder bruges kun til den aktuelle videogenerering og slettes automatisk fra serverne efter behandlingen. De gemmes eller bruges aldrig til andre formål.',
        faq6Question: 'Hvilke billedformater understøttes?',
        faq6Answer: 'Vi understøtter almindelige formater som JPG, PNG og WEBP. For bedste kysseffekt anbefaler vi fotos med tydelige ansigtstræk og godt lys, med en opløsning på mindst 512x512 pixels.',
        
        // How to Use Section
        howToUseTitle: 'Hvordan bruger du vores AI Kys-video generator?',
        howToUseDesc: 'Tre trin til at få billeder til at forelske sig:',
        step1Title: 'Trin 1: Upload billeder',
        step1Desc: 'Vælg to fotos af personer, kæledyr eller figurer, du vil "matche" (både portrætter og gruppefotos virker).',
        step2Title: 'Trin 2: Vælg tilstand',
        step2Desc: 'Vælg ønsket kyssetype (f.eks. fransk kys, kindkys, håndkys) eller indtast en brugerdefineret prompt.',
        step3Title: 'Trin 3: Generér video',
        step3Desc: 'Klik på generér, og AI’en tryller på få sekunder og giver dig en sød eller sjov kyssevideo!',
        
        // Explore Others Section
        exploreOthersTitle: 'Udforsk andre populære videoeffekter hos WeryAI',
        aiDancing: 'AI dans',
        videoFaceSwap: 'AI video ansigtsbytning',
        videoToAnime: 'AI video til anime',
        videoUpscaler: 'Videoopskalering',
        
        // Model Introduction Section
        modelIntroTitle: 'Slip kreativiteten løs og begynd at lave fantastiske kyssevideoer med WeryAI',
        modelIntroDescription: 'Prøv vores AI Kys-video generator',
        modelIntroButtonText: 'Prøv WeryAI Kys-video generator gratis',
        modelIntroFooterText: 'Intet kreditkort kræves',
    },
    no: {
        // Page Title
        pageTitle: 'AI Kyss',
        previewTitle: 'AI Kyss-videogenerator',
        
        // Labels
        labelType: 'Type',
        labelImage: 'Bilde',
        
        // Type Types
        typeFrenchKiss: 'AI fransk kyss',
        typeGeneral: 'Generelt',
        typeKissMe: 'Kiss Me AI',
        typeCheekKiss: 'Kyss på kinnet',
        
        // Upload Related
        addImage: 'Legg til bilde',
        clickToUpload: 'Klikk for å laste opp et bilde',
        uploading: 'Laster opp...',
        
        // Switch Options
        backgroundMusic: 'Bakgrunnsmusikk',
        publicVisibility: 'Gjør offentlig',
        copyProtection: 'Opphavsrettsbeskyttelse',
        
        // Tooltip Messages
        backgroundMusicTooltip: 'Hvis aktivert kan du velge blant musikksporene vi har forberedt og legge dem til i den genererte videoen.',
        publicVisibilityTooltip: 'Ved å aktivere dette kan WeryAI velge arbeidet ditt og publisere det i fellesskapskatalogen.',
        copyrightProtectionTooltip: 'Beskytt opplastede bilder, videoer og prompts mot å bli vist i fellesskapet. Når dette er aktivert, kan andre WeryAI-brukere ikke se bildene, videoene og promptene du lastet opp for å generere dette innholdet i fellesskapet.',
        
        // Prompt Messages
        imageTip: 'Vennligst last opp ett bilde med én eller to personer. Videoen genererer automatisk en kysseffekt.',
        maxTwoImages: 'Maks 2 bilder tillatt',
        pleaseSelectImage: 'Velg en bildefil',
        imageTooLarge: 'Bildestørrelsen må ikke overstige 100 MB',
        uploadSuccess: 'Opplasting vellykket',
        uploadFailed: 'Opplasting mislyktes',
        noPreview: 'Ingen forhåndsvisning tilgjengelig',
        
        // Error and Status Messages
        errorNoImage: 'Last opp minst ett bilde',
        infoStart: 'Oppgaven ble sendt!',
        failedSubmit: 'Kunne ikke sende oppgaven',
        errorGeneral: 'Kunne ikke opprette video',
        
        // Button Info
        btnInfo: 'Prøv AI Kyss-videogenerator gratis',
        
        // Introduction Section
        introduceTitle: 'AI Kyss-videogenerator - gi to bilder liv med et kyss',
        introduceDesc: 'Vil du se idolet ditt kysse en animefigur? Eller gi parbildene liv? WeryAI Kyss-videogenerator trenger bare to bilder for å lage realistiske kyssvideoer. Enten det er et romantisk fransk kyss, et søtt kyss på kinnet eller et lekent luftkyss, gjenskaper AI alt og bryter dimensjonsgrenser med kreativitet!',
        
        // Reason Selection Section
        selectReasonTitle: 'Hvorfor velge WeryAI Kyss-videogenerator?',
        reason1Title: 'Ultrarealistisk AI-bevegelse, glatt og naturlig',
        reason1Desc: 'Si farvel til stive, robotaktige bevegelser! Takket være banebrytende bildedrevne algoritmer genererer WeryAI kyssvideoer med flytende hodebevegelser, naturlige mikrouttrykk og realistiske hudteksturer – en visuell opplevelse som føles ekte.',
        reason2Title: 'Flere kyssmoduser, tilpass romantikken',
        reason2Desc: 'Fra forsiktige kyss til lidenskapelige franske kyss og kjærlige kinnkyss. Du kan fritt bruke prompts for å styre stil og intensitet, og skape intime øyeblikk som matcher fantasien din.',
        reason3Title: 'Alt kan kysse – ubegrenset kreativitet',
        reason3Desc: 'Bryt med virkeligheten! La to urelaterte kjendiser "gå offentlig", få katten og hunden din til å "bli forelsket", eller la en statue kysse en figur i et maleri. WeryAI støtter miks av ekte mennesker, anime, kjæledyr, skulpturer og mer – perfekt for virale memer.',
        reason4Title: 'Blikkfang i sosiale medier',
        reason4Desc: 'Lei av vanlig tekst og bilder? Skil deg ut på TikTok, Instagram eller i feeden din med en unik AI-kyssvideo! Enten det er en høytidsbekjennelse, en prank på venner eller markedsmateriell, er dette en helt ny måte å fange oppmerksomhet på.',
        
        // FAQ Section
        faqTitle: 'Ofte stilte spørsmål',
        faq1Question: 'Hva er en AI Kyss-videogenerator?',
        faq1Answer: 'Det er et AI-verktøy som bruker deep learning til å gjøre statiske bilder om til dynamiske kyssvideoer. Bare last opp bilder, så analyserer WeryAI ansiktstrekk og genererer glatte animasjoner av to personer (eller en person og en gjenstand) som kysser. Brukes mye til underholdning, sosial deling og kreativ produksjon.',
        faq2Question: 'Hvilke typer kyssvideoer kan jeg lage?',
        faq2Answer: 'Nesten ingen grenser! Du kan lage romantiske franske kyss mellom par, lekne kinnkyss mellom venner, eller til og med kjærlighet på tvers av dimensjoner. Så lenge du har kreativitet, kan AI hjelpe deg å realisere det.',
        faq3Question: 'Ser de genererte kyssvideoene realistiske ut?',
        faq3Answer: 'Veldig realistiske. WeryAI bruker bransjeledende bildedrevne modeller som fokuserer på fysikklogikk og hudtekstur ved ansiktskontakt, slik at kyssbevegelsene blir både glatte og naturlige og reduserer "uncanny valley"-effekten kraftig.',
        faq4Question: 'Kan jeg bruke AI Kyss-generatoren gratis?',
        faq4Answer: 'Ja! Vi tilbyr gratis prøvepoeng slik at alle kan oppleve gleden ved AI-skaping. Du kan generere videoer og forhåndsvise effekter gratis, og deretter avgjøre om du vil oppgradere for høyere kvalitet.',
        faq5Question: 'Er bildenes personvern trygt?',
        faq5Answer: 'Helt trygt. Vi tar personvernet ditt på alvor. Alle opplastede bilder brukes kun til gjeldende videogenerering og slettes automatisk fra serverne etter behandling. De lagres eller brukes aldri til andre formål.',
        faq6Question: 'Hvilke bildeformater støttes?',
        faq6Answer: 'Vi støtter vanlige formater som JPG, PNG og WEBP. For best kyssresultat anbefaler vi bilder med tydelige ansiktstrekk og god belysning, med oppløsning på minst 512x512 piksler.',
        
        // How to Use Section
        howToUseTitle: 'Hvordan bruke vår AI Kyss-videogenerator?',
        howToUseDesc: 'Tre steg for å få bilder til å forelske seg:',
        step1Title: 'Steg 1: Last opp bilder',
        step1Desc: 'Velg to bilder av personer, kjæledyr eller figurer du vil "matche" (både enkeltportretter og gruppebilder fungerer).',
        step2Title: 'Steg 2: Velg modus',
        step2Desc: 'Velg ønsket kyssetype (f.eks. fransk kyss, kinnkyss, håndkyss) eller skriv inn en egendefinert prompt.',
        step3Title: 'Steg 3: Generer video',
        step3Desc: 'Klikk generer, og AI gjør magien sin på få sekunder og gir deg en søt eller morsom kyssvideo!',
        
        // Explore Others Section
        exploreOthersTitle: 'Utforsk andre populære videoeffekter på WeryAI',
        aiDancing: 'AI dans',
        videoFaceSwap: 'AI video ansiktsbytte',
        videoToAnime: 'AI video til anime',
        videoUpscaler: 'Videooppskalering',
        
        // Model Introduction Section
        modelIntroTitle: 'Slipp kreativiteten løs og begynn å lage fantastiske kyssvideoer med WeryAI',
        modelIntroDescription: 'Prøv vår AI Kyss-videogenerator',
        modelIntroButtonText: 'Prøv WeryAI Kyss-videogenerator gratis',
        modelIntroFooterText: 'Ingen kredittkort kreves',
    },
    nl: {
        // Page Title
        pageTitle: 'AI Kussen',
        previewTitle: 'AI Kussen Video Generator',
        
        // Labels
        labelType: 'Type',
        labelImage: 'Afbeelding',
        
        // Type Types
        typeFrenchKiss: 'AI Franse kus',
        typeGeneral: 'Algemeen',
        typeKissMe: 'Kiss Me AI',
        typeCheekKiss: 'Kus op de wang',
        
        // Upload Related
        addImage: 'Afbeelding toevoegen',
        clickToUpload: 'Klik om een afbeelding te uploaden',
        uploading: 'Bezig met uploaden...',
        
        // Switch Options
        backgroundMusic: 'Achtergrondmuziek',
        publicVisibility: 'Openbaar maken',
        copyProtection: 'Copyrightbescherming',
        
        // Tooltip Messages
        backgroundMusicTooltip: 'Als ingeschakeld kun je kiezen uit de muziektracks die we hebben voorbereid om toe te voegen aan de gegenereerde video.',
        publicVisibilityTooltip: 'Door deze optie in te schakelen kan WeryAI je werk selecteren en publiceren in de community-directory.',
        copyrightProtectionTooltip: 'Bescherm je geüploade afbeeldingen, video\'s en prompts zodat ze niet in de community worden getoond. Als dit is ingeschakeld kunnen andere WeryAI-gebruikers de afbeeldingen, video\'s en prompts die je hebt geüpload om deze content te genereren niet zien.',
        
        // Prompt Messages
        imageTip: 'Upload één afbeelding met één of twee personen. De video genereert automatisch een kusseneffect.',
        maxTwoImages: 'Maximaal 2 afbeeldingen toegestaan',
        pleaseSelectImage: 'Selecteer een afbeeldingsbestand',
        imageTooLarge: 'Afbeelding mag niet groter zijn dan 100 MB',
        uploadSuccess: 'Upload geslaagd',
        uploadFailed: 'Upload mislukt',
        noPreview: 'Geen previewvideo beschikbaar',
        
        // Error and Status Messages
        errorNoImage: 'Upload minstens één afbeelding',
        infoStart: 'Taak succesvol ingediend!',
        failedSubmit: 'Taak indienen mislukt',
        errorGeneral: 'Video maken mislukt',
        
        // Button Info
        btnInfo: 'Probeer AI Kussen Video Generator gratis',
        
        // Introduction Section
        introduceTitle: 'AI Kussen Video Generator - breng twee foto\'s tot leven met een kus',
        introduceDesc: 'Wil je je idool een animepersonage zien kussen? Of je koppel­foto\'s tot leven brengen? De WeryAI Kussen Video Generator heeft maar twee foto\'s nodig om realistische kusvideo\'s te maken. Of het nu een romantische Franse kus is, een zoete kus op de wang of een speelse luchtkus, AI recreëert het allemaal perfect en doorbreekt de grens tussen dimensies met creativiteit!',
        
        // Reason Selection Section
        selectReasonTitle: 'Waarom kiezen voor de WeryAI Kussen Video Generator?',
        reason1Title: 'Ultrarealistische AI-beweging, soepel en natuurlijk',
        reason1Desc: 'Zeg vaarwel tegen stijve, robotachtige bewegingen! Dankzij geavanceerde beeldgestuurde algoritmen genereert WeryAI kusvideo\'s met vloeiende hoofdbewegingen, natuurlijke micro-expressies en realistische huidtexturen, voor een visuele ervaring alsof je er echt bij bent.',
        reason2Title: 'Meerdere kusmodi, pas je romance aan',
        reason2Desc: 'Van zachte kusjes tot gepassioneerde Franse kussen en liefdevolle wangkussen. Je kunt vrij prompts invoeren om stijl en intensiteit nauwkeurig te sturen en intieme momenten te creëren die perfect bij je verbeelding passen.',
        reason3Title: 'Alles kan kussen - onbeperkte creativiteit',
        reason3Desc: 'Breek los van de realiteit! Laat twee ongerelateerde beroemdheden "publiek" gaan, laat je kat en hond "verliefd" worden of laat een standbeeld een personage in een schilderij kussen. WeryAI ondersteunt het mixen van echte mensen, anime, huisdieren, sculpturen en meer—perfect voor virale memes.',
        reason4Title: 'Aandachtstrekker op social media',
        reason4Desc: 'Klaar met saaie tekst en beelden? Val op op TikTok, Instagram of je social feed met een unieke AI-kusvideo! Of het nu een feestelijke liefdesverklaring is, een prank bij vrienden of marketingmateriaal, dit is een gloednieuwe manier om direct aandacht te trekken.',
        
        // FAQ Section
        faqTitle: 'Veelgestelde vragen',
        faq1Question: 'Wat is een AI Kussen Video Generator?',
        faq1Answer: 'Het is een AI-tool die deep learning gebruikt om statische afbeeldingen om te zetten in dynamische kusvideo\'s. Upload simpelweg foto\'s, en WeryAI analyseert gezichtskenmerken om automatisch vloeiende animaties van twee mensen (of een persoon en een object) die kussen te genereren. Veel gebruikt voor entertainment, social sharing en creatieve productie.',
        faq2Question: 'Wat voor kusvideo\'s kan ik maken?',
        faq2Answer: 'Bijna geen grenzen! Je kunt romantische Franse kussen tussen koppels maken, speelse wangkussen tussen vrienden, of zelfs een cross-dimensionale mens-machine-romance. Zolang je creatief bent, helpt AI je het te realiseren.',
        faq3Question: 'Zien de gegenereerde kusvideo\'s er realistisch uit?',
        faq3Answer: 'Zeer realistisch. WeryAI gebruikt toonaangevende beeldgestuurde modellen die zich richten op het optimaliseren van fysische logica en huidtextuur tijdens gezichtscontact, waardoor de kusbewegingen soepel en natuurlijk zijn en het "uncanny valley"-effect sterk wordt verminderd.',
        faq4Question: 'Kan ik de AI Kussen Generator gratis gebruiken?',
        faq4Answer: 'Ja! We bieden gratis proefpunten zodat iedereen de fun van AI-creatie kan ervaren. Je kunt video\'s genereren en effecten gratis previewen, en daarna beslissen of je wilt upgraden voor hogere kwaliteit.',
        faq5Question: 'Is de privacy van mijn foto\'s veilig?',
        faq5Answer: 'Absoluut veilig. We nemen je privacy zeer serieus. Alle geüploade afbeeldingen worden alleen gebruikt voor de huidige videogeneratie en worden na verwerking automatisch van de servers verwijderd. Ze worden nooit opgeslagen of gebruikt voor andere doeleinden.',
        faq6Question: 'Welke afbeeldingsformaten worden ondersteund?',
        faq6Answer: 'We ondersteunen gangbare formaten zoals JPG, PNG en WEBP. Voor het beste kusseneffect raden we aan foto\'s te uploaden met duidelijke gezichtskenmerken en goede belichting, met een resolutie van minimaal 512x512 pixels.',
        
        // How to Use Section
        howToUseTitle: 'Hoe gebruik je onze AI Kussen Video Generator?',
        howToUseDesc: 'Drie stappen om foto\'s verliefd te maken:',
        step1Title: 'Stap 1: Upload foto\'s',
        step1Desc: 'Kies twee foto\'s van mensen, huisdieren of personages die je wilt "matchen" (zowel portretten als groepsfoto\'s werken).',
        step2Title: 'Stap 2: Kies modus',
        step2Desc: 'Kies het gewenste type kus (bijv. Franse kus, kus op de wang, handkus, enz.) of voer een aangepaste prompt in.',
        step3Title: 'Stap 3: Genereer video',
        step3Desc: 'Klik op genereren en AI doet zijn magie in seconden, en presenteert je een zoete of grappige kusvideo!',
        
        // Explore Others Section
        exploreOthersTitle: 'Ontdek andere populaire video-effecten op WeryAI',
        aiDancing: 'AI dansen',
        videoFaceSwap: 'AI video gezichtsruil',
        videoToAnime: 'AI video naar anime',
        videoUpscaler: 'Video-opschaler',
        
        // Model Introduction Section
        modelIntroTitle: 'Ontketen je creativiteit en maak geweldige kusvideo\'s met WeryAI',
        modelIntroDescription: 'Probeer onze AI Kussen Video Generator',
        modelIntroButtonText: 'Probeer WeryAI Kussen Video Generator gratis',
        modelIntroFooterText: 'Geen creditcard nodig',
    },
    id: {
        // Page Title
        pageTitle: 'AI Ciuman',
        previewTitle: 'Generator Video Ciuman AI',
        
        // Labels
        labelType: 'Tipe',
        labelImage: 'Gambar',
        
        // Type Types
        typeFrenchKiss: 'Ciuman Prancis AI',
        typeGeneral: 'Umum',
        typeKissMe: 'Kiss Me AI',
        typeCheekKiss: 'Ciuman pipi',
        
        // Upload Related
        addImage: 'Tambah gambar',
        clickToUpload: 'Klik untuk mengunggah gambar',
        uploading: 'Mengunggah...',
        
        // Switch Options
        backgroundMusic: 'Musik latar',
        publicVisibility: 'Jadikan publik',
        copyProtection: 'Perlindungan hak cipta',
        
        // Tooltip Messages
        backgroundMusicTooltip: 'Jika diaktifkan, Anda bisa memilih dari daftar musik yang kami sediakan untuk ditambahkan ke video yang dibuat.',
        publicVisibilityTooltip: 'Dengan mengaktifkan opsi ini, WeryAI dapat memilih karya Anda dan mempublikasikannya ke direktori komunitas.',
        copyrightProtectionTooltip: 'Lindungi gambar, video, dan prompt yang Anda unggah agar tidak ditampilkan di komunitas. Jika diaktifkan, pengguna WeryAI lain tidak dapat melihat gambar, video, dan prompt yang Anda unggah untuk membuat konten ini di komunitas.',
        
        // Prompt Messages
        imageTip: 'Silakan unggah satu gambar berisi satu atau dua orang. Video akan otomatis menghasilkan efek ciuman.',
        maxTwoImages: 'Maksimal 2 gambar',
        pleaseSelectImage: 'Silakan pilih file gambar',
        imageTooLarge: 'Ukuran gambar tidak boleh melebihi 100MB',
        uploadSuccess: 'Unggah berhasil',
        uploadFailed: 'Unggah gagal',
        noPreview: 'Tidak ada video pratinjau',
        
        // Error and Status Messages
        errorNoImage: 'Silakan unggah setidaknya satu gambar',
        infoStart: 'Tugas berhasil dikirim!',
        failedSubmit: 'Gagal mengirim tugas',
        errorGeneral: 'Gagal membuat video',
        
        // Button Info
        btnInfo: 'Coba Generator Video Ciuman AI gratis',
        
        // Introduction Section
        introduceTitle: 'Generator Video Ciuman AI - Hidupkan dua foto dengan ciuman',
        introduceDesc: 'Ingin melihat idola Anda mencium karakter anime? Atau menghidupkan foto pasangan? Generator Video Ciuman WeryAI hanya membutuhkan dua foto untuk membuat video ciuman yang realistis. Baik ciuman Prancis yang romantis, ciuman pipi yang manis, maupun ciuman udara yang playful, AI merekonstruksi semuanya dengan sempurna dan menembus batas dimensi lewat kreativitas!',
        
        // Reason Selection Section
        selectReasonTitle: 'Mengapa memilih Generator Video Ciuman WeryAI?',
        reason1Title: 'Gerakan AI ultra-realistis, halus dan alami',
        reason1Desc: 'Ucapkan selamat tinggal pada gerakan kaku seperti robot! Berkat algoritma berbasis gambar yang mutakhir, WeryAI menghasilkan video ciuman dengan gerak kepala yang mulus, mikro-ekspresi wajah yang natural, dan tekstur kulit yang realistis, memberikan pengalaman visual seolah Anda benar-benar di sana.',
        reason2Title: 'Beragam mode ciuman, sesuaikan romantismu',
        reason2Desc: 'Dari ciuman ringan hingga ciuman Prancis yang penuh gairah dan ciuman pipi yang manis. Anda bisa memasukkan prompt untuk mengontrol gaya dan intensitas ciuman secara presisi, menciptakan momen intim yang sesuai imajinasi Anda.',
        reason3Title: 'Semua bisa berciuman - kreativitas tanpa batas',
        reason3Desc: 'Bebaskan diri dari realitas! Buat dua selebritas yang tak terkait "go public", biarkan kucing dan anjing Anda "jatuh cinta", atau bahkan membuat patung mencium karakter dalam lukisan. WeryAI mendukung kombinasi manusia nyata, anime, hewan peliharaan, patung, dan lainnya—sempurna untuk membuat meme viral.',
        reason4Title: 'Penarik perhatian di media sosial',
        reason4Desc: 'Bosan dengan teks dan gambar biasa? Tampil menonjol di TikTok, Instagram, atau feed sosial dengan video ciuman AI yang unik! Baik untuk pengakuan cinta di hari spesial, prank teman, atau materi pemasaran, ini adalah cara baru untuk menarik perhatian dengan cepat.',
        
        // FAQ Section
        faqTitle: 'Pertanyaan yang sering diajukan',
        faq1Question: 'Apa itu Generator Video Ciuman AI?',
        faq1Answer: 'Ini adalah alat AI yang menggunakan deep learning untuk mengubah gambar statis menjadi video ciuman yang dinamis. Cukup unggah foto, dan WeryAI menganalisis fitur wajah untuk secara otomatis menghasilkan animasi halus dua orang (atau orang dan objek) yang berciuman. Banyak digunakan untuk hiburan, berbagi sosial, dan produksi kreatif.',
        faq2Question: 'Jenis video ciuman apa yang bisa saya buat?',
        faq2Answer: 'Hampir tidak ada batas! Anda bisa membuat ciuman Prancis romantis antara pasangan, ciuman pipi yang playful antara teman, atau bahkan romansa manusia-mesin lintas dimensi. Selama Anda kreatif, AI dapat mewujudkannya.',
        faq3Question: 'Apakah video ciuman yang dihasilkan terlihat realistis?',
        faq3Answer: 'Sangat realistis. WeryAI menggunakan model berbasis gambar terdepan yang fokus mengoptimalkan logika fisika dan tekstur kulit saat kontak wajah, memastikan gerakan ciuman halus dan natural serta mengurangi efek "uncanny valley" pada video AI tradisional.',
        faq4Question: 'Bisakah saya menggunakan Generator Ciuman AI secara gratis?',
        faq4Answer: 'Ya! Kami menyediakan poin uji coba gratis agar setiap pengguna bisa merasakan keseruan kreasi AI. Anda dapat membuat video dan pratinjau efek secara gratis, lalu memutuskan apakah perlu upgrade untuk kualitas lebih tinggi.',
        faq5Question: 'Apakah privasi foto saya aman?',
        faq5Answer: 'Sangat aman. Kami sangat serius mengenai privasi Anda. Semua gambar yang diunggah hanya digunakan untuk pembuatan video saat ini dan akan dihapus otomatis dari server setelah diproses. Tidak akan disimpan atau digunakan untuk tujuan lain.',
        faq6Question: 'Format gambar apa yang didukung?',
        faq6Answer: 'Kami mendukung format umum seperti JPG, PNG, dan WEBP. Untuk hasil ciuman terbaik, kami merekomendasikan foto dengan fitur wajah jelas dan pencahayaan baik, dengan resolusi minimal 512x512 piksel.',
        
        // How to Use Section
        howToUseTitle: 'Bagaimana menggunakan Generator Video Ciuman AI kami?',
        howToUseDesc: 'Tiga langkah agar foto jatuh cinta:',
        step1Title: 'Langkah 1: Unggah foto',
        step1Desc: 'Pilih dua foto orang, hewan peliharaan, atau karakter yang ingin Anda "jodohkan" (potret tunggal atau foto grup sama-sama bisa).',
        step2Title: 'Langkah 2: Pilih mode',
        step2Desc: 'Pilih jenis ciuman yang diinginkan (misalnya ciuman Prancis, ciuman pipi, ciuman tangan, dll.), atau masukkan prompt kustom.',
        step3Title: 'Langkah 3: Buat video',
        step3Desc: 'Klik generate, dan AI akan bekerja dalam hitungan detik, menyajikan video ciuman yang manis atau lucu!',
        
        // Explore Others Section
        exploreOthersTitle: 'Jelajahi efek video populer lainnya di WeryAI',
        aiDancing: 'AI menari',
        videoFaceSwap: 'AI tukar wajah video',
        videoToAnime: 'AI video ke anime',
        videoUpscaler: 'Peningkatan video',
        
        // Model Introduction Section
        modelIntroTitle: 'Lepaskan kreativitasmu dan mulai membuat video ciuman yang menakjubkan dengan WeryAI',
        modelIntroDescription: 'Coba Generator Video Ciuman AI kami',
        modelIntroButtonText: 'Coba Generator Video Ciuman WeryAI gratis',
        modelIntroFooterText: 'Tidak perlu kartu kredit',
    },
    tr: {
        // Page Title
        pageTitle: 'AI Öpüşme',
        previewTitle: 'AI Öpüşme Video Oluşturucu',
        
        // Labels
        labelType: 'Tür',
        labelImage: 'Görsel',
        
        // Type Types
        typeFrenchKiss: 'AI Fransız Öpücüğü',
        typeGeneral: 'Genel',
        typeKissMe: 'Kiss Me AI',
        typeCheekKiss: 'Yanak Öpücüğü',
        
        // Upload Related
        addImage: 'Görsel ekle',
        clickToUpload: 'Görsel yüklemek için tıkla',
        uploading: 'Yükleniyor...',
        
        // Switch Options
        backgroundMusic: 'Arka plan müziği',
        publicVisibility: 'Herkese açık',
        copyProtection: 'Telif hakkı koruması',
        
        // Tooltip Messages
        backgroundMusicTooltip: 'Etkinleştirildiğinde, hazırladığımız müzik parçalarından seçim yapıp üretilen videoya ekleyebilirsiniz.',
        publicVisibilityTooltip: 'Bu seçeneği etkinleştirirseniz WeryAI çalışmanızı seçip topluluk dizininde yayınlayabilir.',
        copyrightProtectionTooltip: 'Yüklediğiniz görsellerin, videoların ve promptların toplulukta görünmesini engeller. Etkinleştirildiğinde diğer WeryAI kullanıcıları bu içeriği oluşturmak için yüklediğiniz görselleri, videoları ve promptları göremez.',
        
        // Prompt Messages
        imageTip: 'Lütfen içinde bir veya iki kişinin olduğu tek bir görsel yükleyin. Video otomatik olarak öpüşme efekti oluşturur.',
        maxTwoImages: 'Maksimum 2 görsel',
        pleaseSelectImage: 'Lütfen bir görsel dosyası seçin',
        imageTooLarge: 'Görsel boyutu 100MB\'ı aşmamalı',
        uploadSuccess: 'Yükleme başarılı',
        uploadFailed: 'Yükleme başarısız',
        noPreview: 'Önizleme videosu yok',
        
        // Error and Status Messages
        errorNoImage: 'Lütfen en az bir görsel yükleyin',
        infoStart: 'Görev başarıyla gönderildi!',
        failedSubmit: 'Görev gönderilemedi',
        errorGeneral: 'Video oluşturulamadı',
        
        // Button Info
        btnInfo: 'AI Öpüşme Video Oluşturucuyu ücretsiz dene',
        
        // Introduction Section
        introduceTitle: 'AI Öpüşme Video Oluşturucu - iki fotoğrafı bir öpücükle canlandır',
        introduceDesc: 'İdolünüzün bir anime karakterini öpmesini mi görmek istiyorsunuz? Ya da çift fotoğraflarınızı canlandırmak mı? WeryAI Öpüşme Video Oluşturucu sadece iki fotoğrafla gerçekçi öpüşme videoları üretir. Romantik bir Fransız öpücüğü, tatlı bir yanak öpücüğü veya oyuncu bir hava öpücüğü olsun, AI hepsini kusursuz şekilde yeniden oluşturur ve yaratıcılıkla boyutlar arası sınırları aşar!',
        
        // Reason Selection Section
        selectReasonTitle: 'Neden WeryAI Öpüşme Video Oluşturucu?',
        reason1Title: 'Ultra gerçekçi AI hareketi, pürüzsüz ve doğal',
        reason1Desc: 'Sert, robotik hareketlere veda edin! En gelişmiş görüntü odaklı algoritmalar sayesinde WeryAI, akıcı baş hareketleri, doğal mikro yüz ifadeleri ve gerçekçi cilt dokularıyla öpüşme videoları üretir; gerçekten oradaymış hissi verir.',
        reason2Title: 'Birden çok öpüşme modu, romantizmini özelleştir',
        reason2Desc: 'Nazik öpücüklerden tutkulu Fransız öpücüklerine ve sevgi dolu yanak öpücüklerine kadar. Promptları özgürce girerek öpüşmenin stilini ve yoğunluğunu hassas biçimde kontrol edebilir, hayalinizdeki yakın anları yaratabilirsiniz.',
        reason3Title: 'Her şey öpüşebilir - sınırsız yaratıcılık',
        reason3Desc: 'Gerçekliğin dışına çıkın! Birbiriyle alakasız iki ünlüyü “açığa çıkarın”, kediniz ve köpeğinizin “aşık olmasını” sağlayın ya da bir heykelin bir tablodaki karakteri öpmesini sağlayın. WeryAI; gerçek insanlar, anime, evcil hayvanlar, heykeller ve daha fazlasını birleştirmenizi destekler—viral meme üretimi için mükemmel.',
        reason4Title: 'Sosyal medyada dikkat çekici',
        reason4Desc: 'Sıradan metin ve görsellerden sıkıldınız mı? Benzersiz bir AI öpüşme videosuyla TikTok, Instagram veya sosyal akışınızda öne çıkın! İster tatil itirafı, ister arkadaşlara şaka, ister pazarlama materyali olsun, bu anında dikkat çekmenin yepyeni bir yolu.',
        
        // FAQ Section
        faqTitle: 'Sıkça Sorulan Sorular',
        faq1Question: 'AI Öpüşme Video Oluşturucu nedir?',
        faq1Answer: 'Statik görselleri dinamik öpüşme videolarına dönüştüren, deep learning teknolojisini kullanan bir AI aracıdır. Fotoğrafları yükleyin, WeryAI yüz özelliklerini analiz edip iki kişinin (veya kişi ve nesnenin) öpüşmesini gösteren akıcı animasyonlar üretir. Eğlence, sosyal paylaşım ve yaratıcı üretimde yaygın olarak kullanılır.',
        faq2Question: 'Ne tür öpüşme videoları oluşturabilirim?',
        faq2Answer: 'Neredeyse sınır yok! Çiftler arasında romantik Fransız öpücükleri, arkadaşlar arasında şakacı yanak öpücükleri ya da boyutlar arası insan-makine romantizmi oluşturabilirsiniz. Yeter ki yaratıcılığınız olsun, AI bunu gerçekleştirir.',
        faq3Question: 'Üretilen öpüşme videoları gerçekçi görünüyor mu?',
        faq3Answer: 'Çok gerçekçi. WeryAI, yüz temasında fiziksel mantık ve cilt dokusunu optimize etmeye odaklanan sektör lideri görüntü tabanlı modeller kullanır. Böylece öpüşme hareketleri pürüzsüz ve doğal olur, geleneksel AI videolarındaki “uncanny valley” etkisi büyük ölçüde azalır.',
        faq4Question: 'AI Öpüşme Oluşturucuyu ücretsiz kullanabilir miyim?',
        faq4Answer: 'Evet! Her kullanıcının AI yaratıcılığının keyfini çıkarması için ücretsiz deneme puanları sağlıyoruz. Videoları ücretsiz oluşturup önizleyebilir, sonra daha yüksek kalite için yükseltmeye karar verebilirsiniz.',
        faq5Question: 'Fotoğraf gizliliğim güvende mi?',
        faq5Answer: 'Kesinlikle güvenli. Gizliliğinizi çok ciddiye alıyoruz. Tüm yüklenen görseller yalnızca mevcut video üretimi için kullanılır ve işlemden sonra sunuculardan otomatik olarak silinir. Asla saklanmaz veya başka amaçla kullanılmaz.',
        faq6Question: 'Hangi görsel formatları destekleniyor?',
        faq6Answer: 'JPG, PNG ve WEBP gibi yaygın görsel formatlarını destekliyoruz. En iyi öpüşme efekti için, yüz hatları belirgin ve ışığı iyi fotoğraflar yüklemenizi öneririz; minimum 512x512 piksel çözünürlük idealdir.',
        
        // How to Use Section
        howToUseTitle: 'AI Öpüşme Video Oluşturucumuzu nasıl kullanırsınız?',
        howToUseDesc: 'Fotoğrafları aşık etmek için üç adım:',
        step1Title: 'Adım 1: Fotoğrafları yükleyin',
        step1Desc: '"Eşleştirmek" istediğiniz kişilerin, evcil hayvanların veya karakterlerin iki fotoğrafını seçin (tekli portreler veya grup fotoğrafları olur).',
        step2Title: 'Adım 2: Mod seçin',
        step2Desc: 'İstediğiniz öpüşme türünü seçin (ör. Fransız öpücüğü, yanak öpücüğü, el öpücüğü vb.) veya özel bir prompt girin.',
        step3Title: 'Adım 3: Video oluştur',
        step3Desc: 'Oluştur’a tıklayın; AI birkaç saniye içinde büyüsünü yapar ve size tatlı ya da komik bir öpüşme videosu sunar!',
        
        // Explore Others Section
        exploreOthersTitle: 'WeryAI\'deki diğer popüler video efektlerini keşfedin',
        aiDancing: 'AI dans',
        videoFaceSwap: 'AI video yüz değiştirme',
        videoToAnime: 'AI video’dan anime',
        videoUpscaler: 'Video yükseltme',
        
        // Model Introduction Section
        modelIntroTitle: 'Yaratıcılığını serbest bırak ve WeryAI ile harika öpüşme videoları oluşturmaya başla',
        modelIntroDescription: 'AI Öpüşme Video Oluşturucumuzu dene',
        modelIntroButtonText: 'WeryAI Öpüşme Video Oluşturucuyu ücretsiz dene',
        modelIntroFooterText: 'Kredi kartı gerekmez',
    },
}

